import {
  AlertAuditLog,
  AlertObjectsGroup,
  AlertObjectsGroupParams,
  AlertRuleSetDetailsParams,
  AlertsGroupedParams,
  IAlertObjectsImpactedParams,
  IPolicyAlertEntitiesImpacted,
  IPolicyAlertEntitiesImpactedParams,
  IPolicyAlertExternalUserGrouped,
  IPolicyAlertExternalUserParams,
  PolicyAlertCard,
  AlertActionParams,
  AlertAuditLogsParams,
  RuleSetFilterList,
  FetchRulsetDataSourcesParams,
  ICreateDurationFilterParams,
  UpdateAlertAssignmentParams,
  AlertAuditLogDetailsParams,
  FetchRuleSetParams,
  ICreateDocumentFiltersParams,
  ICreateAccessFilterParams,
  IUpdateDocumentFiltersParams,
  IUpdateAccessFilterParams,
  AttributesBySensitivity,
  SaveArchivalLocationParams,
  ActionHistoryParams,
  ObjectAlertActionHistory,
  SubAlertsActionParams,
  ApplySubAlertActionParams,
  AlertAuditLogActionHistoryParams,
  AuditLogActionHistory,
  InformationExtractionParams,
  EmailsImpactedParams,
  PolicyFileTypesFilterParams,
  ObjectsImpactedGenericParams,
  ICreateRansomewareActivityFilterParams,
  IUpdateRansomewareActivityFilterParams,
  QueryAlertIncidentsParams,
  FetchAlertIncidentsUsersFilterParams,
  QueryAlertUsersParams,
  FetchImpactedObjectsParams,
  MutationSuspendUserParams,
  PoliciesState,
  FetchIncidentRecentAccessRecordsParams,
  IncidentRecentAccessRecord,
  IncidentAccessType,
  ICreateUebaFilterParams,
  IUpdateUebaFilterParams,
  FetchExtendedObjectsImpactedParams,
  FetchIncidentRecentAccessObjectParams,
  IncidentRecentAccessObject,
  SubAlertOwnerFilterParams,
  AlertImpactedUsersParams,
  ObjectsOwnedBySubAlertParams,
  PolicyWorkflow,
  PendingRequestLogDetails,
  AlertActionDocumentFilterParams,
  AlertActionMailFilterParams
} from './policiesSlice'
import { AccessPermission, getAccessRulesQueryAccessConditions, AlertStatus } from './v2/constants'
import { mergeWorkflowActionOverrides } from './v2/workflowPolicyMerge'
import {
  AccessPatternConfig,
  ArchiveObjectConfig,
  AutomationConfig,
  DeleteObjectConfig,
  RedactionConfig,
  ReassignObjectsConfig,
  ReassignMode,
  RevokeAccessConfig,
  FrequencyType,
  DisableAccountConfig,
  DisableAccountMode
} from './v2/components/Step4/types'
import { SubAlertActionState, ExtendedSubAlertActionStateFilter } from './constants'
import { UebaUserActivity } from './contexts/RulesetContext'
import {
  IPolicyFilter,
  IGetFiltersParams,
  IProfileMapData,
  IApplyFilterParams,
  ICreateFilterParams,
  ICreatePolicyParams,
  IUpdatePolicyParams,
  ICreateDatasourceFilterParams,
  IPolicy,
  IUpdateFilter,
  IDeletePolicyParams,
  IPageInfo,
  IPolicyListByTypeParam,
  IPolicyFilterProfile,
  IAlertObjectsImpacted,
  IGetPolicyAlertsParams,
  IPolicyAlert,
  FilterParams,
  RulsetInfo,
  IPolicyType,
  IPolicyFilterState,
  IPolicyTypeForPrint,
  ICreateDocumentLabelSetFilterParams,
  DocumentLabelGroup,
  SORT_ORDER,
  ScanConditionsObjectTypesRest,
  ExtendedAlertObjectsImpacted,
  CreateIdpFilterParams,
  CreateUsersFilterParams,
  PolicyActionNotifications,
  SubAlertActionApprovalStates
} from '../../interfaces'
import {
  ALERT_ID,
  FILTER_TYPE,
  LIMIT_DEFAULT,
  API_FILTER_ALERTS,
  ALERT_STATUS_API_MAP,
  SEVERITY_API_MAP,
  DATA_SOURCE_TYPE_API_MAP,
  ALERT_STATUS,
  alertIntermediateStatuses,
  DATA_SOURCE_TYPES,
  MAIL_DATASOURCES,
  ALERT_ASSIGMENT_OPTIONS,
  POLICY_TYPES,
  SENSITIVE_LABEL,
  OBJECT_REVOKE_ACCESS_TYPES,
  AUDIT_LOG_OBJECTS_LIMIT_DEFAULT,
  RETENTION_ATTRIBUTE_TYPES,
  SYSTEM_RETENTION_ATTRIBUTE_TYPES,
  AUTOMATION_ACTIONS,
  SYSTEM_STALE_FILES_CONDITIONS,
  BUCKET_DATASOURCES,
  GRAPHQL_API_FILTERS,
  AlertEmployeeType,
  AlertUserType,
  AccessedByIdentityTypeOptions,
  AccessIntervalTypeOptions,
  mapDataSourceApiTypesToStandard,
  OBJECT_TYPES,
  STALE_USER_TYPES,
  ALERT_ACTIONS
} from '../../constants'
import {
  WorkflowActionBlock,
  WorkflowRecipientGroups
} from '../workflows/views/createWorkflows/types'
import gqlast from '../../utils/filtersUtil'
import { getSortedPolicyTypes } from '../../utils/policyUtils'
import { FolderInfo, SubAlertDateFilterKey } from '../../services/graphqlSchemaTypes'
import { formatDateTimeString } from '../../utils/timeUtil'
import {
  calculateSkipAndLimit,
  getAfterCursor,
  parameterizeArrayofObjects,
  parameterizeFilterArray
} from '../../utils/graphqlUtil'
import { AttributeSet, AttributeSetAttribute } from '../attributes/attributesSlice'
import { sortByOrder } from '../../utils/sortUtil'
import { sortAttributesByInstanceCountAndSensitivity } from '../../utils/attributesUtil'
import { removeDuplicates } from '../../utils'
import { AccessControlAccessMode } from '../accessControl/types'
import { WorkflowBlockType, WorkflowType } from '../workflows/workflowsSlice'
import { escapeNewlineandTab, stringEscape } from '../../utils/stringUtil'
import { convertBlocksToWorkflowFormData } from '../workflows/views/createWorkflows/constants'
import {
  AttributeInstanceCountType,
  AttributeSensitivityType,
  FileClassificationType,
  LabelType,
  RiskScoreType,
  RulesetType
} from '../../utils/rulesetUtils'
import { getCustomDateRange } from '../../utils/urlUtil'
import { gql } from 'graphql-request'

// util functions
const getObjectsImpactedFilters = (params: ObjectsImpactedGenericParams) => {
  const { filters } = params

  let filter = ''
  if (filters?.filter?.length) {
    const filterString = parameterizeArrayofObjects(filters.filter)
    filter += `filter: ${filterString}, `
  }

  let booleanFilter = ''
  if (filters?.booleanFilter?.length) {
    booleanFilter = `booleanFilter: ${parameterizeArrayofObjects(filters.booleanFilter)}, `
  }

  let subAlertFilter = ''
  if (filters?.subAlertFilter?.length) {
    const subAlertFilterString = parameterizeArrayofObjects(filters.subAlertFilter)
    subAlertFilter += `subAlertFilter: ${subAlertFilterString}, `
  }

  let intRangeFilter = ''
  if (filters?.intRangeFilter?.key) {
    intRangeFilter += `intRangeFilter: \
    { key: ${filters.intRangeFilter.key}, \
      min: ${filters.intRangeFilter.min}, \
      max: ${filters.intRangeFilter.max} \
    }, `
  }
  const dateFilterString =
    filters && filters?.dateFilters && filters.dateFilters.length
      ? `dateFilters: ${parameterizeFilterArray(filters.dateFilters, ['key', 'start', 'end'])}`
      : ''

  return { filter, booleanFilter, subAlertFilter, intRangeFilter, dateFilterString }
}

// queries
export const queryProfileFilters = (): string => gql`
  {
    filters(type: PROFILE_FILTERS) {
      count
      edges {
        node {
          id
          name
          owner
          createdAt
          configuration {
            ... on ProfileFilters {
              conditions {
                conditionLabel {
                  edges {
                    node {
                      id
                      labelDisplayName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const queryPolicyAlertsTotals = (params: IGetPolicyAlertsParams): string => {
  const {
    datasourceId,
    datasourceIds = [],
    severity,
    policyType,
    partnerIds,
    subAlertAssignees = [],
    ruleSetIds
  } = params
  const selectedDatasourceIds = Array.from(
    new Set([datasourceId, ...datasourceIds].filter(Boolean))
  )

  const basicFilters: FilterParams = { filter: [] }
  if (severity && basicFilters?.filter) {
    basicFilters.filter?.push({
      key: API_FILTER_ALERTS.SEVERITY,
      values: severity?.split(',')?.map((s) => SEVERITY_API_MAP[s]) || ''
    })
  }
  if (policyType && basicFilters?.filter) {
    basicFilters.filter?.push({
      key: API_FILTER_ALERTS.POLICY_TYPE,
      values: policyType?.split(',') || []
    })
  }
  if (partnerIds && partnerIds?.length && basicFilters?.filter) {
    basicFilters.filter?.push({
      key: API_FILTER_ALERTS.PARTNER_ID_KEY,
      values: partnerIds
    })
  }
  if (ruleSetIds && ruleSetIds?.length && basicFilters?.filter) {
    basicFilters.filter?.push({
      key: API_FILTER_ALERTS.POLICY_INSTANCE,
      values: ruleSetIds?.split(',') || ''
    })
  }
  const activeFilter = {
    key: API_FILTER_ALERTS.STATUS,
    values: [
      ALERT_STATUS_API_MAP[ALERT_STATUS.active],
      ...alertIntermediateStatuses.map((status) => ALERT_STATUS_API_MAP[status])
    ]
  }
  const resolvedFilter = {
    key: API_FILTER_ALERTS.STATUS,
    values: ALERT_STATUS_API_MAP[ALERT_STATUS.resolved]
  }
  const datasourceIdsParam = selectedDatasourceIds.length
    ? `datasourceIds: ${JSON.stringify(selectedDatasourceIds)}`
    : ''

  const allFiltersString = parameterizeArrayofObjects(basicFilters.filter || [])
  const activeFiltersString = parameterizeArrayofObjects([
    ...(basicFilters.filter || []),
    activeFilter
  ])
  const resolvedFiltersString = parameterizeArrayofObjects([
    ...(basicFilters.filter || []),
    resolvedFilter
  ])

  const filterAssignee =
    subAlertAssignees.length > 0 ? `subAlertAssignees: ${JSON.stringify(subAlertAssignees)}` : ''

  const allAlertArgs = [datasourceIdsParam, allFiltersString ? `filter:${allFiltersString}` : '']
    .filter(Boolean)
    .join(', ')
  const activeAlertArgs = [
    datasourceIdsParam,
    activeFiltersString ? `filter:${activeFiltersString}` : ''
  ]
    .filter(Boolean)
    .join(', ')
  const resolvedAlertArgs = [
    datasourceIdsParam,
    resolvedFiltersString ? `filter:${resolvedFiltersString}` : ''
  ]
    .filter(Boolean)
    .join(', ')
  const alertsActiveArgs = [activeAlertArgs, 'first: 1', filterAssignee].filter(Boolean).join(', ')
  const alertsAllArgs = [allAlertArgs, 'first: 1', filterAssignee].filter(Boolean).join(', ')
  const alertsResolvedArgs = [resolvedAlertArgs, 'first: 1', filterAssignee]
    .filter(Boolean)
    .join(', ')

  return gql`
    {
      alertsActive: alert(${alertsActiveArgs}) {
        count
      }
      alertsAll: alert(${alertsAllArgs}) {
        count
      }
      alertsResolved: alert(${alertsResolvedArgs}) {
        count
      }
    }
  `
}

export const mapQueryPolicyAlertsTotals = (
  raw: any
): { activeCount: number; resolvedCount: number; allCount: number } => {
  return {
    allCount: raw?.alertsAll?.count || 0,
    resolvedCount: raw?.alertsResolved?.count || 0,
    activeCount: raw?.alertsActive?.count || 0
  }
}

export const queryPolicyAlerts = (params: IGetPolicyAlertsParams): string => {
  const {
    page,
    pageSize = LIMIT_DEFAULT,
    datasourceId,
    datasourceIds = [],
    severity,
    alertStatus,
    policyType,
    partnerIds,
    subAlertAssignees = [],
    ruleSetIds,
    sortField = 'CREATED_AT',
    sortOrder = -1
  } = params
  const selectedDatasourceIds = Array.from(
    new Set([...(datasourceId ? [datasourceId] : []), ...datasourceIds].filter(Boolean))
  )

  const cursor = getAfterCursor(page, pageSize)

  const filters: FilterParams = { filter: [] }

  if (ruleSetIds && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.POLICY_INSTANCE,
      values: ruleSetIds?.split(',') || ''
    })
  }
  if (severity && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.SEVERITY,
      values: severity?.split(',')?.map((s) => SEVERITY_API_MAP[s]) || ''
    })
  }
  if (alertStatus && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.STATUS,
      values: alertStatus?.map((a) => ALERT_STATUS_API_MAP[a]) || ''
    })
  }
  if (policyType && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.POLICY_TYPE,
      values: policyType?.split(',') || []
    })
  }
  if (partnerIds && partnerIds?.length && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.PARTNER_ID_KEY,
      values: partnerIds
    })
  }

  const queryParams: string[] = []
  if (selectedDatasourceIds.length > 0) {
    queryParams.push(`datasourceIds: ${JSON.stringify(selectedDatasourceIds)}`)
  }
  const filterString = parameterizeArrayofObjects(filters?.filter || [])
  if (filterString) {
    queryParams.push(`filter:${filterString}`)
  }

  const hasSubAlertAssignees = subAlertAssignees?.length > 0
  if (hasSubAlertAssignees) {
    queryParams.push(`subAlertAssignees: ${JSON.stringify(subAlertAssignees)}`)
  }
  queryParams.push(`first: ${pageSize}`)
  queryParams.push(`after: "${cursor}"`)
  queryParams.push(`sortField: ${sortField}`)
  queryParams.push(`sortByAsc: ${sortOrder == 1}`)

  return gql`
    {
      alert(${queryParams.join(', ')}) {
        count
        edges {
          node {
            id
            name
            severity
            generatedAt
            lastModifiedTime
            status
            subAlertAssignees(limit: 2) {
              totalCount
              assignees
            }
            objectCount
            ${!hasSubAlertAssignees ? 'entities { count }' : ''}
            datasource {
              edges {
                node {
                  id
                  type
                  name
                }
              }
            }
            policy {
              edges {
                node {
                  policyType {
                    edges {
                      node {
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapQueryPolicyAlerts = (
  raw: any
): {
  list: IPolicyAlert[]
  total: number
} => {
  const { edges, count } = raw?.alert

  const list = edges?.map(({ node: alert }) => ({
    id: alert?.id,
    name: alert?.name,
    severity: alert?.severity,
    status: alert?.status,
    assignees: alert?.subAlertAssignees?.assignees,
    assigneesCount: alert?.subAlertAssignees?.totalCount,
    entitiesCount: alert?.entities?.count ?? 0,
    objects: alert?.objectCount,
    createdAt: alert?.generatedAt ? formatDateTimeString(alert?.generatedAt) : '',
    lastModified: alert?.lastModifiedTime,
    dataSource: alert?.datasource?.edges[0]?.node?.name || '',
    dataSourceId: alert?.datasource?.edges[0]?.node?.id || '',
    dataSourceType: alert?.datasource?.edges[0]?.node?.type || '',
    policyName: alert?.policy?.edges[0]?.node?.policyType?.edges[0]?.node?.name
  }))

  return { list, total: count }
}

export const queryPolicyAlertCards = (params: AlertsGroupedParams): string => {
  const { filters, subAlertAssignees = [] } = params
  let filtersParamString = ''
  const filterString = filters?.filter?.length
    ? parameterizeArrayofObjects(filters?.filter || [])
    : ''
  if (filterString) {
    filtersParamString += `filter:${filterString}`
  }
  const filterAssignee =
    subAlertAssignees?.length > 0 ? `subAlertAssignees: ${JSON.stringify(subAlertAssignees)}` : ''

  return gql`
    {
      alertGroupByDatasource(first: 999, ${filtersParamString}, ${filterAssignee}) {
        edges {
          node {
            datasourceType
            datasource {
              count
            }
            ${!filterAssignee ? 'entitiesImpactedCount' : ''}
            objectCount
            alertCount
            policyViolatedCount
          }
        }
      }
    }
  `
}

export const mapQueryRuleSetFilterList = (raw: any): RuleSetFilterList[] => {
  try {
    return raw?.policy?.edges?.map(({ node }) => ({
      id: node?.id,
      name: node?.name
    }))
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const queryRuleSetFilterList = () => gql`
  {
    policy {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const mapQueryPolicyAlertCards = (raw: any): PolicyAlertCard[] => {
  const cards = raw?.alertGroupByDatasource?.edges?.map(({ node: item }) => ({
    dataSourceType: item?.datasourceType,
    dataSourceName: item?.datasource,
    entitiesCount: item?.entitiesImpactedCount ?? 0,
    documentsCount: item?.objectCount,
    alertsCount: item?.alertCount,
    policiesCount: item?.policyViolatedCount
  }))

  return cards
}

export const queryPolicyFilters = (params: IGetFiltersParams): string => gql`
  {
    filters(type: ${params[FILTER_TYPE]}) {
      count
      edges {
        node {
          id
          name
          owner
          createdAt
        }
      }
    }
  }
`
export const queryPolicyFilterByIds = (ids: string[]): string => {
  const idsStrArr = ids?.map((id) => '"' + id + '"')
  return gql`
  {
    filters(filterIds: [${idsStrArr?.join(',')}]) {
      edges {
        node {
          id
          name
          type
          configuration {
            ... on ProfileFilters {
              conditions {
                conditionLabel {
                  edges {
                    node {
                      id
                      labelDisplayName
                    }
                  }
                }
              }
            }
            ... on DocumentLabelSetFilters {
              documentLabelSets {
                documentLabelSetId
              }
            }
            ... on TimeBasedFilters {
              valueType
              value
              attributeType
              attributeValue {
                ...on MetadataValueOutput{
                  metadataId
                }
              }
            }
            ... on DocumentLabelsFilters {
              operator
              groups {
                operator
                filterLabels: documentLabels {
                  labelId
                  labelSetId
                }
              }
            }
            ... on DatasourceFilters {
              datasource {
                edges {
                  node {
                    id
                    name
                    type
                    createdBy
                  }
                }
              }
              datasourceWithScanConditions {
                datasourceId
                scanConditions {
                  ...on UnstructuredDatasourcePolicyScanConditionOutput {
                    filterType
                    objectType
                    objectValues {
                      ... on UnstructuredDatasourcePolicyScanConditionStringWrapperOutput{
                      value
                    }
                    ... on SMBDatasourcePolicyScanConditionOutput{
                      shareName
                      path
                    }
                    }
                    objectMetadata {
                      id
                      name
                    }
                  }
                }
              }
            }
            ... on DocumentFiltersOutput {
              operator
              groups {
                operator
                type
                riskScore
                attributeInstanceCounts {
                  attributeId
                  minCount
                  maxCount
                }
                documentLabels {
                  labelId
                  labelSetId
                }
                attributeSensitivityCounts {
                  attributeSensitivityLabel
                  minCount
                }
                fileClassificationSet {
                  fileClass
                  fileSubClass
                }
              }
            }
            ... on AccessFiltersOutput {
              accessRules{
                accessType{
                  type
                  subType
                }
                accessConditions{
                  operator
                  conditions {
                    conditionType
                    conditionArg{
                      ... on AccessTypeArgOutput {
                        accessTypeOp
                        accessTypeValues{
                          accessMode
                        }
                      }
                      ... on AccessorAttributeArgOutput {
                        accessorAttributeOp
                        attributeType
                      }
                      ... on AccessorAggregationArgOutput {
                        accessorAggregationConditionOp
                        aggregationOp
                        conditionValues
                      }
                    }
                  }
                }
              }
            }
            ... on AttributeSetFilters {
              attributeSet {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
            ... on FileExtensionsFiltersOutput {
              fileExtensions
            }
            ... on ExcessiveWritesFiltersOutput {
              accessCount
              accessInterval {
                value
                valueType
              }
              accessedByIdentityType
            }
            ... on IdpFiltersOutput {
              idpIds
              idp {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
            ... on UsersFiltersOutput {
              userType
              conditions {
                ... on InactiveUserTimeConfigOutput {
                  attributeType
                  value
                  valueType
                }
                ... on GuestUserOutput {
                  guestUserTypes
                }
                ... on DeactivatedUserOutput {
                  deactivatedUserTypes
                }
              }
            }
          }
        }
      }
    }
  }
`
}

export const queryApplyFilterCondtion = (params: IApplyFilterParams): string => gql`
  {
    profileMaps(id:"${params?.id}", ${
  params?.conditions?.length > 0 ? `conditions: "${params?.conditions}"` : ''
}) {
      count
      edges {
        node {
          profileMapData
          mapping {
            sourceField
            isSensitive
            attribute
            confidence
          }
        }
      }
    }
  }
`

export const queryDataSourcesbyFilterIds = ({
  filterIds = []
}: FetchRulsetDataSourcesParams): string => {
  const idsStrArr = filterIds?.map((id) => '"' + id + '"')
  return gql`
  {
    filters(type: DATA_SOURCE_FILTERS, filterIds: [${idsStrArr?.join(',')}]) {
      edges {
        node {
          id
          configuration {
            ... on DatasourceFilters {
              datasource {
                edges {
                  node {
                    id
                    name
                    type
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
}

export const mapQueryDataSourcesbyFilterIds = (raw: any): any => {
  return (
    raw?.filters?.edges[0]?.node?.configuration?.datasource?.edges?.map(({ node }) => node) || []
  )
}

export const queryProfileMapData = (profileMapId: string): string => gql`
  {
    profileMaps(id:"${profileMapId}") {
      count
      edges {
        node {
          profileMapData
          mapping {
            sourceField
            isSensitive
            attribute
            confidence
            sourceFieldIndex
          }
          fileName
          totalRecordCount
          filteredRecordCount
        }
      }
    }
  }
`

export const queryCreateFilter = (params: ICreateFilterParams): any => {
  const query = gqlast`mutation {
    createFilter( clientMutationId: ${params?.profileMapId}
    filterData: {
      name: ${params?.name}
      owner: "admin"
      description: ""
      type: PROFILE_FILTERS
      configuration: {
        profileFilters: {
          profileMapId: ${params?.profileMapId}
          conditions: ${params?.conditions}
        }
      }
    })
    {
      clientMutationId
    }}
  `

  return gql`
    ${query}
  `
}

export const queryUpdateProfileMap = (params: any): any => {
  const query = gqlast`mutation {
    updateProfileMap( id: ${params?.profileMapId}
    clientMutationId: ${params?.profileMapId}
    mappingInput: ${params?.columns}
  )
    {
      profileMap {
        edges{
          node{
            mapping{
              sourceField
              isSensitive
              attribute
              confidence
            }
          }
        }
      }
    }}
  `
  return gql`
    ${query}
  `
}

export const queryPolicyWorkflows = (): string => {
  return gql`
    {
      flow(filter:[{key: ${GRAPHQL_API_FILTERS.type}, values: ["${WorkflowType.POLICY_NOTIFICATION_AND_APPROVAL}"]}] ) {
        edges {
          node {
            id
            name
            type
            blocks {
              id
              order
              type
              config {
                __typename
                ... on PolicyTemplateUpsertNotificationObject {
                  enabled
                  recipientGroups
                  additionalRecipients
                }
                ... on PolicyAlertAssignmentObject {
                  enabled
                  additionalRecipients
                  assignmentGroup
                }
                ... on PolicyTemplateStateNotificationObject {
                  enabled
                  states
                  recipientGroups
                  additionalRecipients
                  cronExpression
                }
                ... on PolicyTemplateStateApprovalObject {
                  enabled
                  states
                  approverGroups
                  additionalApprovers
                  cronExpression
                }
                ... on PolicyTemplateActionsNotificationsAndApprovalsObject {
                  configs {
                    id
                    actionType
                    notificationsEnabled
                    notificationRecipientGroups
                    additionalNotificationRecipients
                    approvalEnabled
                    approverGroups
                    additionalApprovers
                  }
                  cronExpression
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapQueryPolicyWorkflows = (raw: any): PolicyWorkflow[] => {
  try {
    const list = raw.flow.edges.map(({ node }) => ({
      id: node?.id,
      name: node?.name || '',
      type: node?.type || '',
      blocks: convertBlocksToWorkflowFormData(node?.blocks)
    }))
    return list
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const queryPolicyTypes = (): string => gql`
  {
    policyType {
      edges {
        node {
          name
          id
          description
          classification
          alerts(first: 1, filter: { key: STATUS, values: "${AlertStatus.active}" }) {
            count
          }
          policy {
            count
          }
        }
      }
    }
  }
`

export const queryPoliciesTypeCards = (): string => gql`
  {
    policyType {
      edges {
        node {
          id
          name
          classification
          description
          policy {
            count
          }
          datasources {
            count
          }
          alerts(first: 1, filter: { key: STATUS, values: "Active" }) {
            count
          }
          permittedObjects {
            count
          }
          permittedEntitiesCount
          permittedAttributesCount
        }
      }
    }
  }
`

export const mapQueryPoliciesTypeCards = (raw: any): IPolicyType[] => {
  const { edges } = raw?.policyType
  const policyTypes: IPolicyType[] = []
  edges?.forEach((edge) => {
    const { node } = edge
    policyTypes?.push({
      name: node?.name,
      id: node?.id,
      prefix: node?.classification,
      description: node?.description,
      policiesCount: node?.policy?.count || 0,
      datasourcesCount: node?.datasources?.count || 0,
      alertsCount: node?.alerts?.count || 0,
      permittedObjectsCount: node?.permittedObjects?.count || 0,
      permittedAttributesCount: node?.permittedAttributesCount || 0,
      permittedEntitiesCount: node?.permittedEntitiesCount || 0
    })
  })

  return getSortedPolicyTypes(policyTypes)
}

export const queryRulesets = (params?: FetchRuleSetParams): string => {
  const {
    datasourceId,
    policyDatasourceIds,
    first,
    after,
    policyType,
    datasourceType,
    severity,
    instanceName,
    has_alerts
  } = params || {}
  let dataSourceIdFilter = ''
  if (datasourceId) {
    dataSourceIdFilter = `datasourceIds : ${JSON.stringify([datasourceId])}, `
  }
  const filters: FilterParams = { filter: [], booleanFilter: [] }
  if (policyType && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.TYPE,
      values: policyType?.split(',') || []
    })
  }
  if (datasourceType && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.DATA_SOURCE_TYPE,
      values: datasourceType?.split(',')?.map((ds) => DATA_SOURCE_TYPE_API_MAP[ds]) || ''
    })
  }
  if (severity && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.SEVERITY,
      values: severity?.split(',')?.map((s) => SEVERITY_API_MAP[s]) || ''
    })
  }

  if (has_alerts !== undefined) {
    filters.booleanFilter?.push({
      key: API_FILTER_ALERTS.HAS_ALERTS,
      value: has_alerts
    })
  }

  const policyInstanceSearchString = instanceName ? `, policySearchInput: "${instanceName}"` : ''

  const filterString = filters.filter?.length
    ? `, filter: ${parameterizeArrayofObjects(filters.filter)}`
    : ''

  const booleanFilterString = filters.booleanFilter?.length
    ? `, booleanFilter: ${parameterizeArrayofObjects(filters.booleanFilter)}`
    : ''
  const dataSourceFilterString = policyDatasourceIds
    ? `, datasourceIds: ${JSON.stringify(policyDatasourceIds)}`
    : ''
  const paginationParams = first
    ? `(first: ${first}, after: "${after}"${dataSourceFilterString}${filterString}${booleanFilterString}${policyInstanceSearchString} sortField: NAME, sortByAsc: true)`
    : ''

  return gql`
    {
      policyCount: policy${paginationParams} {
        count
      }
      policy${paginationParams} {
        edges {
          node {
            id
            name
            status
            alert(first: 1, ${dataSourceIdFilter} filter: { key: STATUS, values: "Active" }) {
              count
            }
            policyType {
              edges {
                node {
                  id
                  classification
                  name
                }
              }
            }
            createdAt
            permittedObjects {
              count
            }
            permittedEntitiesCount
            permittedAttributesCount
          }
        }
      }
    }
  `
}

export const mapQueryRulesets = (raw: any): { list: RulsetInfo[]; total: number } => {
  try {
    const list: RulsetInfo[] = raw?.policy?.edges?.map(({ node }) => ({
      id: node?.id,
      name: node?.name,
      status: node?.status,
      type: node?.policyType?.edges[0]?.node?.name,
      prefix: node?.policyType?.edges[0]?.node?.classification,
      policyTypeId: node?.policyType?.edges[0]?.node?.id,
      createdAt: node?.createdAt,
      permittedEntitiesCount: node?.permittedEntitiesCount || 0,
      alertsCount: node?.alert?.count || 0,
      permittedAttributesCount: node?.permittedAttributesCount || 0,
      permittedObjectsCount: node?.permittedObjects?.count || 0
    }))

    return { list, total: raw?.policyCount?.count || 0 }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const queryRulesetsForPrint = (): string => gql`
  {
    policy {
      edges {
        node {
          id
          name
          policyFilters {
            filterIds
          }
          policyType {
            edges {
              node {
                name
                classification
              }
            }
          }
          alert(first: 100) {
            edges {
              node {
                objectCount
                entities {
                  count
                }
              }
            }
          }
        }
      }
    }
  }
`
export const mapQueryRulesetsForPrint = (raw: any): IPolicyTypeForPrint[] => {
  try {
    const { edges } = raw?.policy
    const policies: IPolicyTypeForPrint[] = []

    edges?.forEach((edge) => {
      const { node } = edge
      const policyType = node?.policyType?.edges[0]?.node
      policies?.push({
        id: node?.id,
        name: node?.name,
        filterIds: node?.policyFilters ? node?.policyFilters[0]?.filterIds : [],
        prefix: policyType?.classification,
        type: policyType?.name,
        objectsCount:
          node?.alert?.edges?.reduce((acc, { node }) => {
            return acc + node?.objectCount
          }, 0) || 0,
        entitiesCount:
          node?.alert?.edges?.reduce((acc, { node }) => {
            return acc + node?.entities?.count
          }, 0) || 0
      })
    })
    return policies?.filter(({ objectsCount = 0 }) => objectsCount > 0)
  } catch (e) {
    console.error(e)
    return []
  }
}
export const queryPoliciesListByType = ({
  first,
  after = '',
  policyType,
  severity,
  datasourceType,
  policyDatasourceIds = [],
  has_alerts,
  instanceName
}: IPolicyListByTypeParam): string => {
  const paginationParams = first ? `first: ${first}, after: "${after}",` : ''
  const policyTypeParam = policyType ? `type: ${policyType}` : ''
  const filters: FilterParams = { filter: [], booleanFilter: [] }
  if (datasourceType && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.DATA_SOURCE_TYPE,
      values: datasourceType?.split(',')?.map((ds) => DATA_SOURCE_TYPE_API_MAP[ds]) || ''
    })
  }
  if (severity && filters?.filter) {
    filters.filter?.push({
      key: API_FILTER_ALERTS.SEVERITY,
      values: severity?.split(',')?.map((s) => SEVERITY_API_MAP[s]) || ''
    })
  }

  if (has_alerts !== undefined) {
    filters.booleanFilter?.push({
      key: API_FILTER_ALERTS.HAS_ALERTS,
      value: has_alerts
    })
  }
  const filterString = filters.filter?.length
    ? `, filter: ${parameterizeArrayofObjects(filters.filter)}`
    : ''
  const booleanFilterString = filters.booleanFilter?.length
    ? `, booleanFilter: ${parameterizeArrayofObjects(filters.booleanFilter)}`
    : ''
  const dataSourceIdsQuery = policyDatasourceIds?.length
    ? `datasourceIds: ${JSON.stringify(policyDatasourceIds)}, `
    : ''

  return gql`
    {
      policy(
        ${paginationParams}
        ${policyTypeParam}
        ${filterString}
        ${booleanFilterString}
        ${dataSourceIdsQuery}
        ${instanceName ? `, policySearchInput: "${instanceName}"` : ''}
        sortField: NAME
        sortByAsc: true
      ) {
        count
        edges {
          node {
            id
            name
            status
            alert(first: 1, filter: { key: STATUS, values: "Active" }) {
            count
          }
            createdAt
            permittedObjects {
              count
            }
            permittedEntitiesCount
            permittedAttributesCount
          }
        }
      }
    }
  `
}

const getFragmentPolicyActions = (
  actionsNotificationsAndApprovals?: PolicyActionNotifications[]
) => {
  if (!actionsNotificationsAndApprovals?.filter((a) => !!a.id)?.length) return ''

  const actionsStringified = actionsNotificationsAndApprovals
    ?.map((action) => {
      return `{
        id: "${action.id}"
        actionType: ${action.actionType}
        notificationRecipientGroups: [${action?.notificationRecipientGroups.join(',')}]
        additionalNotificationRecipients: ${JSON.stringify(action.additionalNotificationRecipients)}
        approverGroups: [${action?.approverGroups.join(',')}]
        additionalApprovers: ${JSON.stringify(action.additionalApprovers)}
      }`
    })
    .join(',')

  return `actionsNotificationsAndApprovals: { configs:  [${actionsStringified}] }`
}

export const queryCreatePolicy = ({
  name,
  description = '',
  policyType,
  policyTemplateId,
  policyUpsertNotifications,
  stateNotifications,
  stateApprovals,
  actionsNotificationsAndApprovals,
  regulations,
  policyFilterIds,
  profileIds,
  datasourceActionIds,
  severity,
  generateAlertSettings,
  notifyUsers,
  flagOnlySourceOfTruthVerified,
  alertAssignment,
  enableAlerts,
  policyFrequencyConfiguration,
  documentLabelOverrideStrategy
}: ICreatePolicyParams): any => {
  const hasConditionsString = generateAlertSettings?.length
  const conditionsString = hasConditionsString
    ? generateAlertSettings?.reduce(
        (conditions, { sensitivity, attributeCount, conditionOperator }, i) =>
          conditions +
          `${i > 0 ? ',' : ''}{sensitivity: ${sensitivity}, attributeCount: ${attributeCount} ${
            conditionOperator ? `, conditionOperator: ${conditionOperator}` : ''
          }}`,
        ''
      )
    : ''

  let alertsAndRegulations =
    policyType == 'DOCUMENT_LABELING_POLICY' || !regulations?.length
      ? ''
      : `regulations: [${regulations?.map((regulation) => regulation)}]
      `
  alertsAndRegulations += `
      notifyAction: {
          raiseAnAlert: ${enableAlerts || false}
        }
    `
  const policyFrequencyConfigurationFragment = policyFrequencyConfiguration
    ? `policyFrequencyConfiguration: {
        type: ${policyFrequencyConfiguration?.type}
        value: ${policyFrequencyConfiguration?.value}
        startFrom: "${policyFrequencyConfiguration?.startFrom}"
        runOn: {
          ${
            policyFrequencyConfiguration?.runOn?.day
              ? `day: ${policyFrequencyConfiguration?.runOn?.day}`
              : ''
          }
          ${
            policyFrequencyConfiguration?.runOn?.type
              ? `type: ${policyFrequencyConfiguration?.runOn?.type}`
              : ''
          }
        }
      }`
    : ''

  const fragmentPolicyTemplate = policyTemplateId
    ? `policyTemplateId: "${policyTemplateId || ''}"`
    : ''

  return gql`mutation {
    createPolicy( clientMutationId: "1"
      policyData: {
        name: "${name}"
        description: "${description}"
        policyType: ${policyType}
        ${fragmentPolicyTemplate}
        policyUpsertNotifications: {
          recipientGroups: [${policyUpsertNotifications?.recipientGroups.join(',')}]
          additionalRecipients: ${JSON.stringify(
            policyUpsertNotifications?.additionalRecipients || []
          )}
        }
        stateNotifications: {
          recipientGroups: [${stateNotifications?.recipientGroups.join(',')}]
          additionalRecipients: ${JSON.stringify(stateNotifications?.additionalRecipients || [])}
        }
        stateApprovals: {
          approverGroups: [${stateApprovals?.recipientGroups.join(',')}]
          additionalApprovers: ${JSON.stringify(stateApprovals?.additionalRecipients || [])}
        }
        ${getFragmentPolicyActions(actionsNotificationsAndApprovals)}
        notifyUsers: ${JSON.stringify(notifyUsers)}
        owner: "admin"
        policyFilters:[{
          filterIds:  ${JSON.stringify(policyFilterIds)}
          profileIds: ${JSON.stringify(profileIds)}
        }]
        policyActions: ${datasourceActionIds ? `${JSON.stringify(datasourceActionIds)}` : '[]'}
        severity: ${severity}
        attributeCondition: [${conditionsString}]
        flagOnlySourceOfTruthVerified:${flagOnlySourceOfTruthVerified}
        ${alertsAndRegulations}
        ${policyFrequencyConfigurationFragment}
        ${
          alertAssignment
            ? `
            subAlertAssignmentStrategy: {
              globalStrategy: ${alertAssignment}
            }
          `
            : ''
        }
        ${
          documentLabelOverrideStrategy
            ? `documentLabelOverrideStrategy: ${documentLabelOverrideStrategy}`
            : ''
        }

      }
    )
    {
      clientMutationId
    }}
  `
}

export const queryUpdatePolicy = ({
  id,
  policyType,
  policyTemplateId,
  policyUpsertNotifications,
  stateNotifications,
  stateApprovals,
  actionsNotificationsAndApprovals,
  description = '',
  severity,
  regulations,
  policyFilterIds,
  profileIds,
  generateAlertSettings,
  notifyUsers,
  datasourceActionIds,
  flagOnlySourceOfTruthVerified,
  enableAlerts,
  policyFrequencyConfiguration,
  documentLabelOverrideStrategy
}: IUpdatePolicyParams): any => {
  const hasConditionsString = generateAlertSettings?.length
  const conditionsString = hasConditionsString
    ? generateAlertSettings?.reduce(
        (conditions, { sensitivity, attributeCount, conditionOperator }, i) =>
          conditions +
          `${i > 0 ? ',' : ''}{sensitivity: ${sensitivity}, attributeCount: ${attributeCount} ${
            conditionOperator ? `, conditionOperator: ${conditionOperator}` : ''
          }}`,
        ''
      )
    : ''
  let alertsAndRegulations =
    policyType == 'DOCUMENT_LABELING_POLICY'
      ? ''
      : `regulations: [${regulations?.map((regulation) => regulation)}]
      `
  alertsAndRegulations += `
      notifyAction: {
          raiseAnAlert: ${enableAlerts || false}
        }
    `

  const policyFrequencyConfigurationFragment = policyFrequencyConfiguration
    ? `policyFrequencyConfiguration: {
          type: ${policyFrequencyConfiguration?.type}
          value: ${policyFrequencyConfiguration?.value}
          startFrom: "${policyFrequencyConfiguration?.startFrom}"
          runOn: {
            ${
              policyFrequencyConfiguration?.runOn?.day
                ? `day: ${policyFrequencyConfiguration?.runOn?.day}`
                : ''
            }
            ${
              policyFrequencyConfiguration?.runOn?.type
                ? `type: ${policyFrequencyConfiguration?.runOn?.type}`
                : ''
            }
          }
        }`
    : ''

  const fragmentPolicyTemplate = policyTemplateId
    ? `policyTemplateId: "${policyTemplateId}"`
    : 'policyTemplateId: null'

  return gql`
  mutation {
    updatePolicy(
      clientMutationId: "updatePolicy"
      id: "${id}"
      policyData: {
        owner: "admin"
        severity: ${severity}
        description: "${description}"
        ${fragmentPolicyTemplate}
        policyUpsertNotifications: {
          recipientGroups: [${policyUpsertNotifications?.recipientGroups.join(',')}]
          additionalRecipients: ${JSON.stringify(
            policyUpsertNotifications?.additionalRecipients || []
          )}
        }
        stateNotifications: {
          recipientGroups: [${stateNotifications?.recipientGroups.join(',')}]
          additionalRecipients: ${JSON.stringify(stateNotifications?.additionalRecipients || [])}
        }
        stateApprovals: {
          approverGroups: [${stateApprovals?.recipientGroups.join(',')}]
          additionalApprovers: ${JSON.stringify(stateApprovals?.additionalRecipients || [])}
        }
        ${getFragmentPolicyActions(actionsNotificationsAndApprovals)}
        attributeCondition: [${conditionsString}]
        notifyUsers: ${JSON.stringify(notifyUsers)}
        flagOnlySourceOfTruthVerified:${flagOnlySourceOfTruthVerified}
        policyFilters: [{
          filterIds: ${JSON.stringify(policyFilterIds)}
          profileIds: ${JSON.stringify(profileIds)}
        }]
        policyActions: ${datasourceActionIds ? `${JSON.stringify(datasourceActionIds)}` : '[]'}
        ${alertsAndRegulations}
        ${policyFrequencyConfigurationFragment}
        ${
          documentLabelOverrideStrategy
            ? `documentLabelOverrideStrategy: ${documentLabelOverrideStrategy}`
            : ''
        }
      }
    ){
      clientMutationId
    }
  }
`
}
export const queryDeletePolicy = (params: IDeletePolicyParams): any => gql`
  mutation {
    deletePolicy(
      clientMutationId: "deletePolicy"
      id: "${params?.id}"
    ){
      isDeleted
    }
  }
`

const getConditionString = (condition) => {
  const isShare = condition.objectType === ScanConditionsObjectTypesRest.sharePath
  const valuesAndMetaDataFragment = isShare
    ? `
    smbFilterValues: [${condition?.objectValues
      ?.map((value) => `{ shareName: "${value?.shareName}" path: "${stringEscape(value?.path)}" }`)
      ?.join(',')}]
  `
    : `objectValues: ${JSON.stringify(condition?.objectValues)}

    objectMetadata: [${condition?.objectMetadata
      ?.map((meta) => `{ id: "${meta?.id}" name: "${meta?.name}" }`)
      ?.join(',')}]`
  return `{
  unstructuredDatasourcePolicyScanConditions: {
    filterType: ${condition?.filterType},
    objectType: ${condition?.objectType},
    ${valuesAndMetaDataFragment}
  }
}`
}

export const queryCreateDatasourceFilter = ({
  datasourceIds,
  anyDatasource,
  scanConditions
}: ICreateDatasourceFilterParams): any => {
  let scanConditionsFragment = ``
  if (scanConditions?.length) {
    scanConditionsFragment = scanConditions
      ?.map(
        (condition) => `
          {
            datasourceId: "${condition?.datasourceId}"
            scanConditions: [
              ${condition?.scanConditions
                ?.map((condition) => getConditionString(condition))
                ?.join(',')}
            ]
          }
        `
      )
      ?.join(',')
  }

  const dataSourcesInfo = anyDatasource
    ? 'conditions: [{filterExpression: "ANY"}]'
    : `datasourceIds: ${JSON.stringify(datasourceIds)}`
  const fragment = scanConditions?.length
    ? `
datasourceWithScanConditions: [${scanConditionsFragment}]
`
    : ''

  return gql`mutation {
    createFilter( clientMutationId: ""
    filterData:{
      name:"Datasource filter-${Math.random()}",
      owner:"Admin",
      description: "This is test filter."
      type:DATA_SOURCE_FILTERS,
      configuration:{
        datasourceFilters: {
          ${fragment}
          ${dataSourcesInfo}
        }
      }
    })
    {
      filter {
        edges {
          node {
            id
          }
        }
      }
    }}
  `
}

export const mutationCreateIdpFilter = ({ idpIds }: CreateIdpFilterParams) => {
  return gql`
    mutation {
      createFilter(
        clientMutationId: ""
        filterData:{
          name: "IDP filter-${Math.random()}",
          owner: "Admin",
          description: "This is test filter."
          type: IDP_FILTERS,
          configuration: {
            idpFilters: {
              idpIds: ${JSON.stringify(idpIds)}
            }
          }
        })
      {
        filter {
          edges {
            node {
              id
              name
              owner
              type
              configuration {
                ... on IdpFiltersOutput {
                  idpIds
                  idp {
                    edges {
                      node {
                        name
                        ownerEmail
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`
}

export const mutationCreateUsersFilter = (params: CreateUsersFilterParams) => {
  const { userType, attributeType, value, valueType, guestUserTypes, deactivatedUserTypes } = params

  let configFragment = ''
  let conditionsFragment = ''

  if (userType === STALE_USER_TYPES.INACTIVE) {
    configFragment = `
      inactiveUserInput: {
        attributeType: ${attributeType}
        value: ${value}
        valueType: ${valueType}
      }`
    conditionsFragment = `
      conditions {
        ... on InactiveUserTimeConfigOutput {
          attributeType
          value
          valueType
        }
      }`
  } else if (userType === STALE_USER_TYPES.GUEST) {
    configFragment = `
      guestUserInput: {
        guestUserTypes: [${guestUserTypes?.join(', ')}]
      }`
    conditionsFragment = `
      conditions {
        ... on GuestUserOutput {
          guestUserTypes
        }
      }`
  } else if (userType === STALE_USER_TYPES.DEACTIVATED) {
    configFragment = `
      deactivatedUserInput: {
        deactivatedUserTypes: [${deactivatedUserTypes?.join(', ')}]
      }`
    conditionsFragment = `
      conditions {
        ... on DeactivatedUserOutput {
          deactivatedUserTypes
        }
      }`
  }

  return gql`
    mutation {
      createFilter(
        clientMutationId: ""
        filterData: {
          name: "Users-${Math.random()}",
          owner: "Admin",
          description: "This is test filter.",
          type: USERS_FILTERS,
          configuration: {
            usersFilters: {
              userType: ${userType}
              ${configFragment}
            }
          }
        }
      ) {
        filter {
          edges {
            node {
              id
              name
              owner
              type
              configuration {
                ... on UsersFiltersOutput {
                  userType
                  ${conditionsFragment}
                }
              }
            }
          }
        }
      }
    }
  `
}

export const queryCreateDocumentLabelSetsFilter = ({
  documentLabelSetId
}: ICreateDocumentLabelSetFilterParams): any => {
  return gql`mutation {
    createFilter( clientMutationId: ""
    filterData:{
      name:"Document label set filter-${Math.random()}",
      owner:"Admin",
      description: "This is test filter."
      type:DOCUMENT_LABEL_SET_FILTERS,
      configuration:{
        documentLabelSetFilters: {
          documentLabelSets: [{
            documentLabelSetId: "${documentLabelSetId}",
          }
      ]
    }
      }
    })
    {
      filter {
        edges {
          node {
            id
          }
        }
      }
    }}
  `
}

export const mutationCreateDurationFilter = ({
  valueType,
  value,
  attributeType
}: ICreateDurationFilterParams): any => {
  const isStaleFilesFilter = attributeType && SYSTEM_STALE_FILES_CONDITIONS.includes(attributeType)
  const attrFragment =
    attributeType &&
    (SYSTEM_RETENTION_ATTRIBUTE_TYPES.includes(attributeType) || isStaleFilesFilter)
      ? `attributeType: ${attributeType}`
      : `
    attributeType: METADATA_ID
    metadataValueInput: {
      metadataId: "${attributeType}"
    }
  `
  return gql`
      mutation {
        createFilter(
          clientMutationId: ""
          filterData: {
            name: "DeleteTimeBasedFilter-${Math.random()}"
            owner: "Admin"
            description: "This is test filter."
            type: TIME_BASED_FILTERS
            configuration: {
              timeBasedFilters: {
                ${attrFragment}
                ${isStaleFilesFilter ? `` : `retentionType: DELETE_ONLY`}
                valueType: ${valueType}
                value: "${value}"
              }
            }
          }
        ) {
          filter {
            edges {
              node {
                id
              }
            }
          }
        }
      }
  `
}

export const mutationCreateFileTypesFilter = ({
  fileExtensions
}: PolicyFileTypesFilterParams): any => {
  return gql`
    mutation createFileTypeFilter {
      createFilter(
        clientMutationId: ""
        filterData: {
          name: "Document filter-${Math.random()}"
          owner: "Admin"
          description: ""
          type: FILE_EXTENSIONS_FILTERS
          configuration: {
            fileExtensionsFilters: {
              fileExtensions: ${JSON.stringify(fileExtensions)}
            }
          }
        }
      ) {
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const mutationUpdateFileTypesFilter = ({
  id,
  fileExtensions
}: PolicyFileTypesFilterParams): any => {
  return gql`
    mutation updateFileTypeFilter {
      updateFilter(
        clientMutationId: ""
        id: "${id}"
        filterData: {
          type: FILE_EXTENSIONS_FILTERS
          configuration: { fileExtensionsFilters: { fileExtensions: ${JSON.stringify(
            fileExtensions
          )} } }
        }
      ) {
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}
const getDocumentLabelsGroupFragment = (groups) => {
  return groups
    ?.map(
      (group) => `{
        operator: ${group?.operator}
        documentLabels: [
          ${group?.documentLabels?.map(
            (label) => `{ labelId: "${label?.labelId}", labelSetId: "${label?.labelSetId}" }`
          )}
        ]
      }`
    )
    ?.join(',')
}
export const mutationCreateDocumentLabelFilter = (params: DocumentLabelGroup): any => {
  return gql`
      mutation {
        createFilter(
          clientMutationId: ""
          filterData: {
            name: "DocumentLabelFilter-${Math.random()}"
            owner: "Admin"
            description: "This is test filter."
            type: DOCUMENT_LABELS_FILTERS
            configuration: {
              documentLabelsFilters: {
                operator: ${params?.operator}
                groups: [${getDocumentLabelsGroupFragment(params?.groups)}]
              }
            }
          }
        ) {
          filter {
            edges {
              node {
                id
              }
            }
          }
        }
      }
  `
}

const getGroupsFragment = (
  group:
    | AttributeSensitivityType
    | AttributeInstanceCountType
    | FileClassificationType
    | LabelType
    | RiskScoreType
) => {
  let fragment = ''
  switch (group?.type) {
    case RulesetType.attributeInstanceCount:
      fragment = `attributeInstanceCounts:[${group?.attributeInstanceCounts
        ?.map(
          (item) =>
            `{attributeId:"${item?.attributeId}", minCount:${item?.minCount}, ${
              item?.maxCount ? `maxCount:${item?.maxCount}` : ''
            }}`
        )
        ?.join(',')}]`
      break
    case RulesetType.attributeSensitivity:
      fragment = `attributeSensitivityCounts:[${group?.attributeSensitivityCounts
        ?.map(
          (item) =>
            `{attributeSensitivityLabel:${item?.attributeSensitivityLabel}, minCount:${item?.minCount}}`
        )
        ?.join(',')}]`
      break
    case RulesetType.classification:
      fragment = `fileClassificationSet:[${group?.fileClassificationSet
        ?.map(
          (item) => `{
        fileClass:"${item?.fileClass}",
        fileSubClass:"${item?.fileSubClass}",
      }`
        )
        ?.join(',')}]`
      break
    case RulesetType.label: {
      fragment = `documentLabels:[${group?.documentLabels
        ?.map(
          (set) => `{
          labelId:"${set?.labelId}",
          labelSetId:"${set?.labelSetId}"
        }`
        )
        ?.join(',')}]`
      break
    }
    case RulesetType.riskScore: {
      fragment = `riskScore: ${group?.riskScore}`
      break
    }
  }
  return fragment
}

const getDocumentFiltersGroupFragment = (groups) => {
  return groups
    ?.map(
      (group) => `{
        ${group?.type === RulesetType.riskScore ? '' : `operator: ${group?.operator}`}
        type: ${group?.type}
        ${getGroupsFragment(group)}
      }`
    )
    ?.join(',')
}

export const mutationCreateDocumentFilter = (params: ICreateDocumentFiltersParams): any => {
  return gql`
    mutation {
      createFilter(
        clientMutationId: ""
        filterData: {
          name: "Document filter-${Math.random()}"
          owner: "Admin"
          description: "This is test filter."
          type: DOCUMENT_FILTERS
          configuration: {
            documentFilters: {
              operator: ${params?.operator}
              groups: [${getDocumentFiltersGroupFragment(params?.groups)}]
            }
          }
        })
        {
          filter {
            edges {
              node {
                id
              }
            }
          }
        }
    }
  `
}

export const mutationUpdateDocumentFilter = (params: IUpdateDocumentFiltersParams): any => {
  return gql`
    mutation {
      updateFilter(
        clientMutationId: ""
        id: "${params?.id}"
        filterData: {
          type: DOCUMENT_FILTERS
          configuration: {
            documentFilters: {
              operator: ${params?.operator}
              groups: [${getDocumentFiltersGroupFragment(params?.groups)}]
            }
          }
        })
        {
          filter {
            edges {
              node {
                id
              }
            }
          }
        }
    }
  `
}

const getAccessRulesForOpenAccess = (params: ICreateAccessFilterParams) => {
  if (!params?.accessSubTypes?.length) return ``

  return params?.accessSubTypes
    ?.map((subType) => {
      return `
      {
        accessType: {
          type: ${params?.accessType}
          subType: ${subType}
        }
        accessConditions: ${getAccessRulesQueryAccessConditions(
          subType,
          params?.excessiveAccessUserCount
        )}
      }
    `
    })
    ?.join('')
}

const accessControlFilterConfigurationFragment = (params: ICreateAccessFilterParams) => {
  return gql`
    configuration: {
      accessFilters: {
        accessRules: [${getAccessRulesForOpenAccess(params)}]
    }
  }`
}

export const mutationCreateAccessFilter = (params: ICreateAccessFilterParams): any => {
  return gql`
    mutation {
      createFilter(
        clientMutationId: ""
        filterData: {
        name: "Access filter-${Math.random()}"
        type: ACCESS_FILTERS
        owner: "Admin"
        ${accessControlFilterConfigurationFragment(params)}
      })
        {
          filter {
            edges {
              node {
                id
              }
            }
          }
        }
    }
  `
}

export const mutationCreateUebaFilter = (params: ICreateUebaFilterParams) => {
  const { uebaConditions } = params

  // Remove conditions which has no schedule enabled
  const enabledUebaConditions = uebaConditions.filter((condition) =>
    Object.keys(condition.schedule).some((schedule) => !!condition.schedule[schedule])
  )

  return gql`
    mutation {
      createFilter(
        clientMutationId: ""
        filterData: {
          name: "UEBA Filter - ${new Date().toISOString()}"
          owner: "Admin"
          description: ""
          type: UEBA_FILTERS
          configuration: {
            uebaFilters: {
              conditions: [
                ${enabledUebaConditions.map(
                  (condition) =>
                    `{ eventType: ${condition.events.toUpperCase()}, schedules: [${Object.keys(
                      condition.schedule
                    )
                      .filter((key) => condition.schedule[key])
                      .map((key) => key.toUpperCase())
                      .join(',')}] }`
                )}
              ]
            }
          }
        }
      ) {
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const mutationUpdateUebaFilter = (params: IUpdateUebaFilterParams) => {
  const { id, uebaConditions } = params

  // Remove conditions which has no schedule enabled
  const enabledUebaConditions = uebaConditions.filter((condition) =>
    Object.keys(condition.schedule).some((schedule) => !!condition.schedule[schedule])
  )

  return gql`
    mutation {
      updateFilter(
        id: "${id}"
        clientMutationId: ""
        filterData: {
          type: UEBA_FILTERS
          configuration: {
            uebaFilters: {
              conditions: [
                ${enabledUebaConditions.map(
                  (condition) =>
                    `{ eventType: ${condition.events.toUpperCase()}, schedules: [${Object.keys(
                      condition.schedule
                    )
                      .filter((key) => condition.schedule[key])
                      .map((key) => key.toUpperCase())
                      .join(',')}] }`
                )}
              ]
            }
          }
        }
      ) {
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const mutationUpdateAccessFilter = (params: IUpdateAccessFilterParams): any => {
  return gql`
    mutation {
      updateFilter(
        clientMutationId: "",
        id: "${params?.id}",
        filterData: {
        type: ACCESS_FILTERS
        ${accessControlFilterConfigurationFragment(params)}
      })
        {
          filter {
            edges {
              node {
                id
              }
            }
          }
        }
    }
  `
}

export const mutationUpdateDocumentLabelFilter = (params: {
  filterData: DocumentLabelGroup
  id: string
}): any => {
  return gql`
      mutation {
        updateFilter(
          clientMutationId: "updateDocumentLabelFilter",
          id: "${params?.id}"
          filterData: {
            type: DOCUMENT_LABELS_FILTERS
            configuration: {
              documentLabelsFilters: {
                operator: ${params?.filterData?.operator}
                groups: [${getDocumentLabelsGroupFragment(params?.filterData?.groups)}]
              }
            }
          }
        ) {
          filter {
            edges {
              node {
                id
              }
            }
          }
        }
      }
  `
}

export const mutationUpdateAlertAssignment = (params: UpdateAlertAssignmentParams): any => {
  return gql`
      mutation {
        modifyPolicyAlertAssignmentStrategy(
          clientMutationId: "mutationUpdateAlertAssignment",
          policyId: "${params?.id}"
          input: {
              globalStrategy: ${params?.alertAssignment}
          }
        ) {
          clientMutationId
        }
      }
  `
}

export const queryUpdateDatasourceFilter = ({
  id,
  dataSourceIds = [],
  anyDatasource = false,
  scanConditions = []
}: IUpdateFilter): any => {
  let scanConditionsFragment = ``
  if (scanConditions?.length) {
    scanConditionsFragment = scanConditions
      ?.map(
        (condition) => `
          {
            datasourceId: "${condition?.datasourceId}"
            scanConditions: [
              ${condition?.scanConditions
                ?.map((condition) => getConditionString(condition))
                ?.join(',')}
            ]
          }
        `
      )
      ?.join(',')
  }

  const dataSourcesInfo = anyDatasource
    ? 'conditions: [{filterExpression: "ANY"}]'
    : `datasourceIds: ${JSON.stringify(dataSourceIds)}`
  const fragment = scanConditions?.length
    ? `
datasourceWithScanConditions: [${scanConditionsFragment}]
`
    : ''

  // const dataSourcesInfo = anyDatasource
  //   ? 'conditions: [{filterExpression: "ANY"}]'
  //   : `datasourceIds: ${JSON.stringify(dataSourceIds)}`

  return gql`
    mutation{
      updateFilter(
        clientMutationId: "updateDatasourceFilter",
        id: "${id}"
        filterData: {
          type: DATA_SOURCE_FILTERS
          configuration: {
            datasourceFilters: {
              ${fragment}
              ${dataSourcesInfo}
            }
          }
        }
      ){
        clientMutationId
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const queryUpdateDocumentLabelSetFilter = ({ id, documentLabelSetId }: IUpdateFilter) => {
  return gql`
    mutation{
      updateFilter(
        clientMutationId: "updateDocumentLabelSetFilter",
        id: "${id}"
        filterData: {
          type: DOCUMENT_LABEL_SET_FILTERS
          configuration: {
            documentLabelSetFilters: {
              documentLabelSets: [{
                  documentLabelSetId: "${documentLabelSetId}",
                }
              ]
            }
          }
        }
      ){
        clientMutationId
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const queryUpdateDurationFilter = ({
  id,
  value,
  valueType,
  attributeType
}: IUpdateFilter) => {
  const isPolicyStaleFiles = attributeType && SYSTEM_STALE_FILES_CONDITIONS.includes(attributeType)
  const attrFragment =
    (attributeType && SYSTEM_RETENTION_ATTRIBUTE_TYPES.includes(attributeType)) ||
    isPolicyStaleFiles
      ? `attributeType: ${attributeType}`
      : `
  attributeType: METADATA_ID
  metadataValueInput: {
    metadataId: "${attributeType}"
  }

`
  return gql`
    mutation{
      updateFilter(
        clientMutationId: "updateDurationFilter",
        id: "${id}"
        filterData: {
          type: TIME_BASED_FILTERS
          configuration: {
            timeBasedFilters: {
              ${attrFragment}
              ${isPolicyStaleFiles ? `` : `retentionType: DELETE_ONLY`}
              valueType: ${valueType}
              value: "${value}"
            }
          }
        }
      ){
        clientMutationId
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const queryCreateAutomationAction = (): any => gql`
  mutation {
    createAction(
      actionData: {
        name: "test-redact-${Math.random()}"
        type: REDACTION
        owner: "Admin"
        configuration: { redactionActionInput: { redactionStrategy: CHARACTER } }
      }
      clientMutationId: ""
    ) {
      clientMutationId
      action {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`

export const mapQueryCreateAutomationAction = (raw: any): { actionId?: string } => {
  let actionId: string | undefined
  const { edges } = raw?.createAction?.action

  if (edges) {
    const [nodeItem] = edges
    if (nodeItem) {
      const { node } = nodeItem
      actionId = node?.id
    }
  }

  return actionId ? { actionId } : {}
}

const getAutomationActionFragment = (params: {
  action: AUTOMATION_ACTIONS
  config:
    | RevokeAccessConfig
    | RedactionConfig
    | AccessPatternConfig
    | ReassignObjectsConfig
    | DisableAccountConfig
    | ArchiveObjectConfig
    | DeleteObjectConfig
}) => {
  if (params?.action === AUTOMATION_ACTIONS.REVOKE_ACCESS) {
    return gql`
       configuration: {
          revokeAccessActionInput: {
          ${getRevokeAccesActionFragment((params?.config as RevokeAccessConfig)?.revokeAction)}
          revokeAccessActionFrequency: {
            type: DAYS
            value: ${(params?.config as RevokeAccessConfig)?.duration}
          }
        }
      }
    `
  } else if (params?.action === AUTOMATION_ACTIONS.REDACTION) {
    return gql`
    configuration: {
      redactionActionInput: {
        redactionStrategy: CHARACTER
      }
    }
    `
  } else if (params?.action === AUTOMATION_ACTIONS.DISABLE_ACCOUNT) {
    if ((params?.config as DisableAccountConfig).disableAccountMode) {
      const config = params?.config as DisableAccountConfig
      const triggerType = config.disableAccountActionFrequency?.type || FrequencyType.IMMEDIATELY
      const frequencyValue =
        triggerType === 'DAYS' && config.disableAccountActionFrequency?.value
          ? `value: ${config.disableAccountActionFrequency.value}`
          : ''

      return gql`
        configuration: {
          disableAccountActionInput: {
            accessPatternConfig: {
              automationTriggersubAlertField: GENERATED_AT
              disableAccountActionDelay: {
                type: ${triggerType}
                ${frequencyValue}
              }
            }
          }
        }
      `
    } else {
      const config = params.config as AccessPatternConfig

      return gql`
        configuration: {
            disableAccountActionInput: {
            accessPatternConfig: {
              consecutiveAccessPatternCount: ${config?.consecutiveAccessPatternCount},
            }
          }
        }
      `
    }
  } else if (params?.action === AUTOMATION_ACTIONS.REASSIGN_OBJECTS) {
    const config = params.config as ReassignObjectsConfig

    let userValue = ''
    if (config.reassignMode === ReassignMode.SPECIFIC_USER && config.user) {
      userValue = config.user
    } else if (config.reassignMode === ReassignMode.DATASOURCE_OWNER && config.user) {
      userValue = config.user
    } else {
      userValue = ''
    }

    const triggerType = config.reassignObjectsActionFrequency?.type || FrequencyType.IMMEDIATELY

    const frequencyValue =
      triggerType === 'DAYS' && config.reassignObjectsActionFrequency?.value
        ? `value: ${config.reassignObjectsActionFrequency.value}`
        : ''

    return gql`
       configuration: {
          reassignObjectsActionInput: {
          reassignMode: ${config.reassignMode}
          user: "${userValue}"
          automationTriggersubAlertField: GENERATED_AT
          reassignObjectsActionDelay: {
            type: ${triggerType}
            ${frequencyValue}
          }
        }
      }
    `
  } else if (params?.action === AUTOMATION_ACTIONS.ARCHIVE_OBJECT) {
    const config = params.config as ArchiveObjectConfig
    return gql`
      configuration: {
        archiveObjectActionInput: {
          archiveObjectActionFrequency: {
            type: DAYS
            value: ${config.duration || 30}
          }
        }
      }
    `
  } else if (params?.action === AUTOMATION_ACTIONS.DELETE_OBJECT) {
    const config = params.config as DeleteObjectConfig
    return gql`
      configuration: {
        deleteObjectActionInput: {
          deleteObjectActionFrequency: {
            type: DAYS
            value: ${config.duration || 30}
          }
        }
      }
    `
  }
  return ``
}

export const queryCreateAutomationActions = (params: {
  action: AUTOMATION_ACTIONS
  datasourceId: string
  config:
    | RevokeAccessConfig
    | RedactionConfig
    | AccessPatternConfig
    | ReassignObjectsConfig
    | DisableAccountConfig
    | ArchiveObjectConfig
    | DeleteObjectConfig
}): any => gql`
  mutation {
    createAction(actionData: {
      name: "automation-action-${Math.random()}",
      type: ${params?.action},
      owner: "Admin"
      datasourceId: "${params?.datasourceId}",
      ${getAutomationActionFragment(params)}
    }, clientMutationId: "1") {
      clientMutationId
      action{
        edges{
          node{
            id
          }
        }
      }
    }
  }

`

export const queryUpdateAutomationActions = (params: {
  id?: string
  action: AUTOMATION_ACTIONS
  datasourceId: string
  config:
    | RevokeAccessConfig
    | RedactionConfig
    | AccessPatternConfig
    | ReassignObjectsConfig
    | DisableAccountConfig
    | ArchiveObjectConfig
    | DeleteObjectConfig
}): any => gql`
  mutation {
    updateAction(actionData: {
      type: ${params?.action},
      ${getAutomationActionFragment(params)}
    }, clientMutationId: "1", actionId: "${params?.id}") {
      clientMutationId
      action{
        edges{
          node{
            id
          }
        }
      }
    }
  }

`

export const mapQueryCreateAutomationActions = (raw: any[]): string[] => {
  const actions: string[] = []
  raw?.forEach((item) => {
    const { action } = item?.createAction || item?.updateAction || {}
    if (action) {
      actions?.push(action?.edges[0]?.node?.id)
    }
  })
  return actions
}

export const queryDeleteAutomationAction = (id: string) => gql`
  mutation {
    deleteAction(clientMutationId: "1", id: "${id}") {
      clientMutationId
      isDeleted
      message
    }
  }`

export const queryAutomationActions = (ids: string[]) => gql`
  query {
    actions(actionIds: ${JSON.stringify(ids)}) {
      edges {
        node {
          id
          type
          datasourceId
          configuration {
            ... on RevokeAccessActionConfig {
              revokeAccessAction {
                revokeAccessType
                subAlertActionType
                revokeAllAccessArgs {
                  accessPermissions
                }
                revokeExternalAccessArgs {
                  accessPermissions
                }
              }
              revokeAccessActionFrequency {
                type
                value
              }
            }
            ... on RedactionAction {
              redactionStrategy
            }
            ... on DisableAccountAction {
              accessPatternConfig {
                consecutiveAccessPatternCount
                disableAccountActionFrequency {
                  type
                  value
                }
              }
            }
            ... on ReassignObjectsActionOutput {
              reassignMode
              user
              reassignObjectsActionFrequency {
                type
                value
              }
            }
            ... on ArchiveObjectActionOutput {
              archiveObjectActionFrequency {
                type
                value
              }
            }
            ... on DeleteObjectActionOutput {
              deleteObjectActionFrequency {
                type
                value
              }
            }
          }
        }
      }
    }
  }`

export const mapQueryAutomationActions = (raw: any): AutomationConfig[] => {
  const actions = raw?.actions?.edges?.map(({ node }) => node)
  if (actions?.length) {
    const configs = actions?.map((action) => {
      const { datasourceId, configuration, type } = action
      const {
        revokeAccessAction,
        redactionStrategy,
        revokeAccessActionFrequency,
        accessPatternConfig,
        reassignMode,
        user,
        reassignObjectsActionFrequency,
        archiveObjectActionFrequency,
        deleteObjectActionFrequency
      } = configuration

      if (revokeAccessAction) {
        const {
          revokeAccessType,
          revokeAllAccessArgs,
          revokeExternalAccessArgs
        } = revokeAccessAction
        const { accessPermissions = [] } = revokeAllAccessArgs || revokeExternalAccessArgs || {}
        const isWrite = accessPermissions?.includes(AccessPermission.Write)
        const revokeAction =
          revokeAccessType === OBJECT_REVOKE_ACCESS_TYPES.all
            ? isWrite
              ? OBJECT_REVOKE_ACCESS_TYPES.allWrite
              : OBJECT_REVOKE_ACCESS_TYPES.all
            : revokeAccessType === OBJECT_REVOKE_ACCESS_TYPES.external
            ? isWrite
              ? OBJECT_REVOKE_ACCESS_TYPES.externalWrite
              : OBJECT_REVOKE_ACCESS_TYPES.external
            : OBJECT_REVOKE_ACCESS_TYPES.link
        return {
          action: AUTOMATION_ACTIONS.REVOKE_ACCESS,
          configuration: [
            {
              datasourceId,
              status: true,
              revokeAction,
              duration: revokeAccessActionFrequency?.value,
              accessPermissions,
              id: action?.id
            }
          ]
        }
      } else if (redactionStrategy) {
        return {
          action: AUTOMATION_ACTIONS.REDACTION,
          configuration: [
            {
              datasourceId,
              status: true,
              redactionStrategy: redactionStrategy,
              id: action?.id
            }
          ]
        }
      } else if (accessPatternConfig) {
        return {
          action: AUTOMATION_ACTIONS.DISABLE_ACCOUNT,
          configuration: [
            {
              id: action?.id,
              datasourceId,
              status: true,
              // Only DISABLE_ACCOUNT is supported (for USERS policy)
              disableAccountMode: DisableAccountMode.DISABLE_ACCOUNT,
              consecutiveAccessPatternCount:
                accessPatternConfig?.consecutiveAccessPatternCount || '',
              disableAccountActionFrequency: accessPatternConfig.disableAccountActionFrequency || {
                type: FrequencyType.IMMEDIATELY,
                value: undefined
              }
            }
          ]
        }
      } else if (reassignMode) {
        return {
          action: AUTOMATION_ACTIONS.REASSIGN_OBJECTS,
          configuration: [
            {
              id: action?.id,
              datasourceId,
              status: true,
              reassignMode,
              user: user || '',
              reassignObjectsActionFrequency: reassignObjectsActionFrequency || {
                type: FrequencyType.IMMEDIATELY,
                value: undefined
              }
            }
          ]
        }
      } else if (type === AUTOMATION_ACTIONS.ARCHIVE_OBJECT) {
        return {
          action: AUTOMATION_ACTIONS.ARCHIVE_OBJECT,
          configuration: [
            {
              id: action?.id,
              datasourceId,
              status: true,
              duration: archiveObjectActionFrequency?.value || 30
            }
          ]
        }
      } else if (type === AUTOMATION_ACTIONS.DELETE_OBJECT) {
        return {
          action: AUTOMATION_ACTIONS.DELETE_OBJECT,
          configuration: [
            {
              id: action?.id,
              datasourceId,
              status: true,
              duration: deleteObjectActionFrequency?.value || 30,
              deleteConfirmText: 'DELETE'
            }
          ]
        }
      }
      return action
    })

    return configs?.reduce((acc, config) => {
      const { action, configuration } = config
      if (action === AUTOMATION_ACTIONS.REVOKE_ACCESS) {
        const accessIdx = acc?.findIndex(
          (item) => item?.action === AUTOMATION_ACTIONS.REVOKE_ACCESS
        )
        if (accessIdx > -1) {
          acc[accessIdx]?.configuration?.push(...configuration)
        } else {
          acc?.push(config)
        }
      } else if (action === AUTOMATION_ACTIONS.REDACTION) {
        const redactionIdx = acc?.findIndex((item) => item?.action === AUTOMATION_ACTIONS.REDACTION)
        if (redactionIdx > -1) {
          acc[redactionIdx]?.configuration?.push(...configuration)
        } else {
          acc?.push(config)
        }
      } else if (action === AUTOMATION_ACTIONS.DISABLE_ACCOUNT) {
        const disableAccIdx = acc?.findIndex(
          (item) => item?.action === AUTOMATION_ACTIONS.DISABLE_ACCOUNT
        )
        if (disableAccIdx > -1) {
          acc[disableAccIdx]?.configuration?.push(...configuration)
        } else {
          acc?.push(config)
        }
      } else if (action === AUTOMATION_ACTIONS.REASSIGN_OBJECTS) {
        const reassignIdx = acc?.findIndex(
          (item) => item?.action === AUTOMATION_ACTIONS.REASSIGN_OBJECTS
        )
        if (reassignIdx > -1) {
          acc[reassignIdx]?.configuration?.push(...configuration)
        } else {
          acc?.push(config)
        }
      } else if (action === AUTOMATION_ACTIONS.ARCHIVE_OBJECT) {
        const archiveIdx = acc?.findIndex(
          (item) => item?.action === AUTOMATION_ACTIONS.ARCHIVE_OBJECT
        )
        if (archiveIdx > -1) {
          acc[archiveIdx]?.configuration?.push(...configuration)
        } else {
          acc?.push(config)
        }
      } else if (action === AUTOMATION_ACTIONS.DELETE_OBJECT) {
        const deleteIdx = acc?.findIndex(
          (item) => item?.action === AUTOMATION_ACTIONS.DELETE_OBJECT
        )
        if (deleteIdx > -1) {
          acc[deleteIdx]?.configuration?.push(...configuration)
        } else {
          acc?.push(config)
        }
      }
      return acc
    }, [] as AutomationConfig[])
  }
  return []
}

export const queryUpdateAttributeSetFilter = ({ id, attributeSetIds }: IUpdateFilter) => gql`
  mutation {
    updateFilter (
      clientMutationId: "updateAttributeSetFilter",
      id: "${id}"
      filterData: {
        type: ATTRIBUTE_SET_FILTERS
        configuration: {
          attributeSetFilters: ${JSON.stringify(attributeSetIds)}
        }
      }
    ){
      clientMutationId
      filter{
        edges{
          node{
            id
          }
        }
      }
    }
  }
`

export const queryPolicyById = (id: string): string => gql`
  {
    policy(id: "${id}") {
      edges {
        node {
          id
          name
          description
          severity
          status
          regulations
          notifyUsers
          flagOnlySourceOfTruthVerified
          documentLabelOverrideStrategy
          subAlertAssignmentStrategy {
            globalStrategy
          }
          notifyAction {
            raiseAnAlert
          }
          attributeCondition {
            sensitivity
            attributeCount
            conditionOperator
          }
          policyFilters {
            profileIds
            filterIds
          }
          policyActions
          alert(first: 1, filter: { key: STATUS, values: "Active" }) {
            count
          }
          policyFrequencyConfiguration {
            type
            value
            startFrom
            runOn {
              day
              type
            }
          }
          policyTemplate {
            edges {
              node {
                id
                name
                blocks {
                  id
                  order
                  type
                  config {
                    __typename
                    ... on PolicyTemplateStateNotificationObject {
                      enabled
                      states
                      cronExpression
                    }
                    ... on PolicyTemplateStateApprovalObject {
                      enabled
                      states
                      cronExpression
                    }
                    ... on PolicyTemplateActionsNotificationsAndApprovalsObject {
                      configs {
                        id
                        actionType
                        notificationsEnabled
                        approvalEnabled
                      }
                    }
                  }
                }
              }
            }
          }
          policyUpsertNotifications {
            recipientGroups
            additionalRecipients
          }
          stateNotifications {
            recipientGroups
            additionalRecipients
          }
          stateApprovals {
            approverGroups
            additionalApprovers
          }
          actionsNotificationsAndApprovals {
            configs {
              id
              actionType
              notificationRecipientGroups
              additionalNotificationRecipients
              approverGroups
              additionalApprovers
            }
          }
        }
      }
    }
  }
`

export const queryPolicyDetailById = (id: string): string => gql`
  {
    policy(id: "${id}") {
      edges {
        node {
          id
          name
          severity
          status
          regulations
          notifyUsers
          subAlertAssignmentStrategy {
            globalStrategy
          }
          policyType {
            edges {
              node {
                id
                name
                classification
                description
              }
            }
          }
          permittedObjects {
            count
          }
          permittedEntitiesCount
          permittedAttributesCount
          alert(first: 1, filter: { key: STATUS, values: "Active" }) {
            count
          }
          policyFilters {
            profileIds
            filterIds
          }
        }
      }
    }
  }
`

export const mapQueryPolicyDetailById = (raw: any): { policy?: IPolicy } => {
  const { edges } = raw?.policy
  if (edges?.length) {
    const { node } = edges[0]
    const {
      policyType: { edges: policyTypeEdges = [] } = {},
      id,
      name,
      severity,
      regulations,
      status,
      policyFilters,
      alert,
      notifyUsers,
      permittedEntitiesCount = 0,
      permittedAttributesCount = 0,
      permittedObjects,
      subAlertAssignmentStrategy
    } = node || {}
    const [nodeItem] = policyTypeEdges || []
    const {
      node: {
        id: policyTypeId = null,
        name: policyType = null,
        description = null,
        classification: prefix = null
      } = {}
    } = nodeItem || {}
    return {
      policy: {
        id,
        name,
        severity,
        regulations,
        status,
        policyFilters,
        policyType,
        policyTypeId,
        description,
        notifyUsers,
        prefix,
        permittedAttributesCount,
        permittedEntitiesCount,
        permittedObjectsCount: permittedObjects?.count || 0,
        alertsCount: alert?.count || 0,
        alertAssignment:
          subAlertAssignmentStrategy?.globalStrategy || ALERT_ASSIGMENT_OPTIONS.DATASOURCE_OWNER
      }
    }
  }
  return {}
}

export const queryCreateAttributeSetFilter = (attributeSetIds: string[]): any => {
  const query = gqlast`mutation {
    createFilter( clientMutationId: ""
      filterData:{
        name:"Attribute set filter-${Math.random()}",
        owner:"Admin",
        type: ATTRIBUTE_SET_FILTERS,
        configuration:{
          attributeSetFilters:${attributeSetIds}
        }
      })
      {
        filter{
          edges{
            node{
              id
            }
          }
        }
      }}
    `
  return gql`
    ${query}
  `
}

export const queryDataSources = (): string => gql`
  {
    query {
      datasources {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`

export const queryAlertAwsBuckets = (params: ObjectsImpactedGenericParams): string => {
  const { page, pageSize = LIMIT_DEFAULT } = params

  const cursor = getAfterCursor(page, pageSize)
  const { filter, booleanFilter, subAlertFilter, intRangeFilter } = getObjectsImpactedFilters(
    params
  )

  return gql`
    {
      objects(
        first: ${pageSize},
        after: "${cursor}",
        ${filter}
        ${booleanFilter}
        ${subAlertFilter}
        ${intRangeFilter}
      ) {
        edges {
          node {
            bucket {
              edges {
                node {
                  name
                  displayName
                }
              }
            }
          }
        }
      }
    }
  `
}
export const mapQueryAlertAwsBuckets = (raw: any): string[] => {
  const bucketNames: string[] = raw?.objects?.edges?.map(({ node: object }) => {
    const bucket = object?.bucket?.edges[0]?.node
    return bucket?.displayName || bucket?.name || ''
  })

  return [...new Set(bucketNames)]
}

export const queryAlertDriveFolders = (params: ObjectsImpactedGenericParams): string => {
  const { page, pageSize = LIMIT_DEFAULT } = params

  const cursor = getAfterCursor(page, pageSize)
  const { filter, booleanFilter, subAlertFilter, intRangeFilter } = getObjectsImpactedFilters(
    params
  )

  return gql`
    {
      objects(
        first: ${pageSize},
        after: "${cursor}",
        ${filter}
        ${booleanFilter}
        ${subAlertFilter}
        ${intRangeFilter}
      ) {
        edges {
          node {
            folder {
              id
              path
            }
          }
        }
      }
    }
  `
}
export const mapQueryAlertDriveFolders = (raw: any): FolderInfo[] => {
  const foldersInfo: FolderInfo[] = raw?.alert?.edges[0]?.node?.subAlerts?.edges
    ?.filter(
      ({ node: subAlert }) =>
        subAlert?.objects?.edges[0]?.node?.folder &&
        subAlert?.objects?.edges[0]?.node?.folder?.path !== '/'
    )
    ?.map(({ node: subAlert }) => subAlert?.objects?.edges[0]?.node?.folder)

  return [...new Map(foldersInfo?.map((folder) => [folder?.id, folder]))?.values()]
}

export const mapQueryCreateDatasourceFilter = (raw: any): { filterId?: string } => {
  let filterId: string | undefined
  const { edges } = raw?.createFilter?.filter

  if (edges) {
    const [nodeItem] = edges
    if (nodeItem) {
      const { node } = nodeItem
      filterId = node?.id
    }
  }

  return filterId ? { filterId } : {}
}

export const mapMutationCreateIdpFilter = (raw: any): { filterId?: string } => {
  let filterId: string | undefined
  const { edges } = raw?.createFilter?.filter

  if (edges) {
    const [nodeItem] = edges
    if (nodeItem) {
      const { node } = nodeItem
      filterId = node?.id
    }
  }

  return filterId ? { filterId } : {}
}

export const mapMutationCreateUsersFilter = (raw: any): { filterId?: string } => {
  let filterId: string | undefined
  const { edges } = raw?.createFilter?.filter

  if (edges) {
    const [nodeItem] = edges
    if (nodeItem) {
      const { node } = nodeItem
      filterId = node?.id
    }
  }

  return filterId ? { filterId } : {}
}

export const mapQueryPoliciesListByType = (
  raw: any
): {
  list: RulsetInfo[]
  total: number
  policyListPageInfo: IPageInfo
} => {
  const { edges, count, pageInfo } = raw?.policy
  const policies: RulsetInfo[] = []

  edges?.forEach((edge) => {
    const { node } = edge

    policies?.push({
      id: node?.id,
      name: node?.name,
      status: node?.status,
      createdAt: node?.createdAt,
      permittedEntitiesCount: node?.permittedEntitiesCount || 0,
      alertsCount: node?.alert?.count || 0,
      permittedAttributesCount: node?.permittedAttributesCount || 0,
      permittedObjectsCount: node?.permittedObjects?.count || 0
    })
  })

  return {
    list: policies,
    total: count,
    policyListPageInfo: pageInfo
  }
}

export const mapQueryPolicyTypes = (raw: any): IPolicyType[] => {
  const { edges } = raw?.policyType
  const policyTypes: IPolicyType[] = []

  edges?.forEach((edge) => {
    const { node } = edge
    policyTypes?.push({
      name: node?.name,
      id: node?.id,
      prefix: node?.classification,
      description: node?.description,
      alertsCount: node?.alerts?.count,
      policiesCount: node?.policy?.count
    })
  })

  return getSortedPolicyTypes(policyTypes)
}

export const mapQueryPolicyFilters = (
  raw: any
): {
  list: IPolicyFilter[]
  total: number
} => {
  const { edges, count } = raw?.filters

  const list: IPolicyFilter[] = edges?.map(({ node }) => {
    const { id, name, createdAt, owner, configuration } = node
    const { conditions = [] } = configuration || {}
    const profiles: IPolicyFilterProfile[] = []
    conditions &&
      conditions?.forEach((cond) => {
        const { conditionLabel: { edges = [] } = {} } = cond
        edges?.forEach((nodeItem) => {
          const { node = null } = nodeItem || {}
          if (node) {
            profiles?.push(node)
          }
        })
      })
    return {
      id,
      name,
      createdAt,
      owner,
      profiles
    }
  })

  return { list, total: count }
}

export const mapApplyFilterCondtion = (
  raw: any
): {
  profileMapData: IProfileMapData[]
} => {
  const { edges } = raw?.profileMaps
  const { profileMapData } = edges[0]?.node

  return { profileMapData: JSON.parse(profileMapData) }
}

export const mapQueryFilter = (
  raw: any
): {
  profileMapId: string
  conditions: Array<{ filterExpression: string }>
} => {
  const { edges } = raw?.filters
  const { configuration } = edges[0]?.node
  const { profileMapId, conditions } = configuration

  return { profileMapId, conditions }
}

export const mapQueryProfileMapData = (
  raw: any
): {
  profileMapData: IProfileMapData[]
  columns: string[]
  profileMapColumnsData: {
    list: any[]
    total: number
  }
  filteredfileName: string
  totalRecordCount: number
  filteredRecordCount: number
} => {
  const { edges } = raw?.profileMaps
  let profileMapColumns = []
  let profileData = []
  let columns: string[] = []
  let filteredfileName = ''
  let totalRecords = 0
  let filteredRecords = 0

  if (edges?.length) {
    const {
      profileMapData = [],
      mapping = [],
      fileName = '',
      totalRecordCount,
      filteredRecordCount
    } = edges[0]?.node
    filteredfileName = fileName
    totalRecords = totalRecordCount
    filteredRecords = filteredRecordCount
    profileMapColumns = mapping
    profileData = JSON.parse(profileMapData)

    if (profileData?.length) {
      columns = Object.keys(profileData[0])
    }
  }
  return {
    columns,
    profileMapData: profileData,
    profileMapColumnsData: {
      list: profileMapColumns,
      total: profileMapColumns?.length
    },
    filteredfileName,
    totalRecordCount: totalRecords,
    filteredRecordCount: filteredRecords
  }
}

export const mapUpdateAttributeSensitivity = (
  raw: any
): {
  list: any[]
  total: number
} => {
  const { edges } = raw?.updateProfileMap?.profileMap
  let profileMapColumns = []

  if (edges?.length) {
    const { mapping = [] } = edges[0]?.node
    profileMapColumns = mapping
  }

  return {
    list: profileMapColumns,
    total: profileMapColumns?.length
  }
}

const mapPolicyNotifications = (
  data
): { recipients: WorkflowRecipientGroups[]; additionalNotificationRecipients: string[] } => {
  return {
    recipients: data?.recipientGroups || data?.approverGroups || [],
    additionalNotificationRecipients: data?.additionalRecipients || data?.additionalApprovers || []
  }
}
const mapRuleSetActions = (actionsData): WorkflowActionBlock[] => {
  const result =
    actionsData?.configs?.map((action) => ({
      id: action?.id || '',
      actionType: action.actionType,
      notificationsEnabled:
        action?.notificationsEnabled ??
        Boolean(
          action?.notificationRecipientGroups?.length ||
            action?.additionalNotificationRecipients?.length
        ),
      notificationRecipientGroups: action.notificationRecipientGroups,
      additionalNotificationRecipients: action.additionalNotificationRecipients,
      approvalEnabled:
        action?.approvalEnabled ??
        Boolean(action?.approverGroups?.length || action?.additionalApprovers?.length),
      approverGroups: action?.approverGroups,
      additionalApproverRecipients: action?.additionalApprovers
    })) || []

  return result
}

export const mapQueryPolicyById = (raw: any): { policy?: IPolicy } => {
  const { edges } = raw?.policy
  if (edges?.length) {
    const { node } = edges[0]
    const { policyType: { edges: policyTypeEdges = [] } = {} } = node || {}
    const [nodeItem] = policyTypeEdges || []
    const { node: { name = null } = {} } = nodeItem || {}

    const workflowStateNotifications = node.policyTemplate?.edges[0]?.node?.blocks?.find(
      (block) => block?.type === WorkflowBlockType.POLICY_STATE_NOTIFICATION
    )
    const workflowStateApprovals = node.policyTemplate?.edges[0]?.node?.blocks?.find(
      (block) => block?.type === WorkflowBlockType.POLICY_STATE_APPROVAL
    )
    const workflowActions = node.policyTemplate?.edges[0]?.node?.blocks?.find(
      (block) => block?.type === WorkflowBlockType.POLICY_ACTION_NOTIFICATION_AND_APPROVAL
    )

    return {
      policy: {
        ...node,
        policyType: name,
        policyTemplateId: node.policyTemplate?.edges[0]?.node?.id,
        policyTemplateName: node.policyTemplate?.edges[0]?.node?.name,
        policyUpsertNotifications: mapPolicyNotifications(node?.policyUpsertNotifications),
        stateNotifications: {
          ...mapPolicyNotifications(node?.stateNotifications),
          states: workflowStateNotifications?.config?.states || []
        },
        stateApprovals: {
          ...mapPolicyNotifications(node?.stateApprovals),
          states: workflowStateApprovals?.config?.states || []
        },
        actionsNotificationsAndApprovals: mergeWorkflowActionOverrides(
          mapRuleSetActions(workflowActions?.config),
          mapRuleSetActions(node?.actionsNotificationsAndApprovals)
        ),
        alertAssignment:
          node?.subAlertAssignmentStrategy?.globalStrategy ||
          ALERT_ASSIGMENT_OPTIONS.DATASOURCE_OWNER,
        alertsCount: node?.alert?.count || 0,
        enableAlerts: node?.notifyAction?.raiseAnAlert
      }
    }
  }
  return {}
}

const getProfileIdFromConfigObj = (configuration) => {
  const profileIds: string[] = []
  if (Array?.isArray(configuration?.conditions)) {
    configuration?.conditions?.forEach((configItem) => {
      const { conditionLabel: { edges = [] } = {} } = configItem || {}
      if (Array?.isArray(edges)) {
        edges?.forEach((nodeItem) => {
          const { node: { id } = null } = nodeItem || {}
          id && profileIds?.push(id)
        })
      }
    })
  }
  return profileIds
}

export const mapQueryPolicyFilterByIds = (raw: any): IPolicyFilterState => {
  const { edges } = raw?.filters
  const result: IPolicyFilterState = { profileFilterIds: [], list: [] }
  if (Array?.isArray(edges)) {
    edges?.forEach((nodeItem) => {
      const { node } = nodeItem || {}
      const { type, id } = node || {}
      if (type === 'PROFILE_FILTERS' && id) {
        result?.profileFilterIds?.push(id)
        const { configuration } = node
        const profileIds = getProfileIdFromConfigObj(configuration)
        result.profileIds = profileIds
        result.list?.push(node)
      } else if (type === 'DATA_SOURCE_FILTERS') {
        const { configuration: { datasource = [], datasourceWithScanConditions = [] } = {} } =
          node || {}

        const flattenedObjectValueScanConditions = datasourceWithScanConditions?.map((ds) => {
          const updatedScanConditions = ds.scanConditions.map((sc) => {
            let { objectValues } = sc

            if (
              Array.isArray(objectValues) &&
              objectValues.length > 0 &&
              objectValues.every(
                (obj) =>
                  typeof obj === 'object' &&
                  obj !== null &&
                  Object.keys(obj).length === 1 &&
                  'value' in obj
              )
            ) {
              objectValues = objectValues?.map((obj) => obj.value)
            }

            return {
              ...sc,
              objectValues
            }
          })

          return {
            ...ds,
            scanConditions: updatedScanConditions
          }
        })

        result.datasourceFilterCreateId = id
        result.datasources =
          datasource?.edges?.map(({ node }) => ({
            ...node,
            dataSourceName: node.name,
            dataSourceType: node.type,
            createdBy: node.createdBy || ''
          })) || []
        result.dataSourceIds = datasource?.edges?.map(({ node }) => node.id) || []
        result.datsourceScanConditions = flattenedObjectValueScanConditions
      } else if (type === 'ATTRIBUTE_SET_FILTERS') {
        const { configuration: { attributeSet = {} } = {} } = node || {}
        result.attributeSetFilterCreateId = id
        result.attributeSets = attributeSet?.edges?.map(({ node }) => node) || []
        result.attributeSetIds = attributeSet?.edges?.map(({ node }) => node.id) || []
      } else if (type === 'DOCUMENT_LABEL_SET_FILTERS') {
        const { id, configuration: { documentLabelSets = [] } = {} } = node || {}
        result.documentLabelSetId = documentLabelSets?.[0]?.documentLabelSetId
        result.documentLabelSetFilterCreateId = id
      } else if (type === 'TIME_BASED_FILTERS') {
        const { id, configuration } = node || {}
        result.durationCount = configuration.value
        result.durationType = configuration.valueType
        if (configuration.attributeType === RETENTION_ATTRIBUTE_TYPES.METADATA_ID) {
          result.attributeType = configuration?.attributeValue?.metadataId
        } else {
          result.attributeType = configuration.attributeType
        }
        result.durationFilterCreateId = id
      } else if (type === 'DOCUMENT_LABELS_FILTERS') {
        const { id, configuration } = node || {}
        const groups = configuration?.groups || []
        result.documentLabelGroups = {
          groups: {
            ...groups,
            documentLabels: groups?.filterLabels || []
          },
          operator: configuration.operator
        }
        result.documentLabelFilterCreateId = id
      } else if (type === 'DOCUMENT_FILTERS') {
        const { id, configuration } = node || {}
        const groups = configuration.groups || []
        result.rulesetGroups = {
          groups,
          operator: configuration?.operator
        }
        result.documentFilterCreateId = id
      } else if (type === 'ACCESS_FILTERS') {
        const { id, configuration } = node || {}
        result.accessFilterCreateId = id
        const rule = configuration?.accessRules?.[0] || {}
        result.accessType = rule?.accessType?.type
        result.accessSubTypes =
          configuration?.accessRules?.map((rule) => rule?.accessType?.subType) || []
        result.excessiveAccessUserCount =
          rule?.accessConditions?.conditions?.find(
            (condition) => condition?.conditionType === 'ACCESSOR_AGGREGATION_OPERATOR_CONDITION'
          )?.conditionArg?.conditionValues?.[0] || 0
      } else if (type === 'FILE_EXTENSIONS_FILTERS') {
        const { configuration: { fileExtensions = [] } = {} } = node || {}
        result.fileTypesFilterCreateId = id
        result.fileExtensions = fileExtensions
      } else if (type === 'EXCESSIVE_WRITES_FILTERS') {
        const {
          id,
          configuration: {
            accessCount = 10,
            accessInterval: { value = 0, type = AccessIntervalTypeOptions.minutes } = {},
            accessedByIdentityType = AccessedByIdentityTypeOptions.user
          } = {}
        } = node || {}
        result.ransomewareActivityFilterCreateId = id
        result.accessCount = accessCount
        result.accessIntervalDuration = Number.parseInt(value, 10)
        result.accessIntervalType = type
        result.accessedByIdentityType = accessedByIdentityType
      } else if (type === 'UEBA_FILTERS') {
        const { id, configuration } = node || {}
        result.uebaFilterCreateId = id
        const uebaConditions = configuration.conditions.map((condition) => {
          const record: UebaUserActivity = {
            events: condition.eventType,
            schedule: {
              DAILY: condition.schedules.includes('DAILY'),
              HOURLY: condition.schedules.includes('HOURLY'),
              WEEKLY: condition.schedules.includes('WEEKLY')
            }
          }

          return record
        })
        result.uebaConditions = uebaConditions
      } else if (type === 'IDP_FILTERS') {
        const { id, configuration: { idpIds = [] } = {} } = node || {}
        result.idpFilterCreateId = id
        result.idpIds = idpIds
      } else if (type === 'USERS_FILTERS') {
        const { configuration } = node || {}
        const { userType, conditions = [] } = configuration || {}

        result.usersFilterCreateId = id
        result.userType = userType

        if (userType === STALE_USER_TYPES.DEACTIVATED) {
          result.deactivatedUserTypes = conditions?.[0]?.deactivatedUserTypes || []
        } else if (userType === STALE_USER_TYPES.GUEST) {
          result.guestUserTypes = conditions?.[0]?.guestUserTypes || []
        } else if (userType === STALE_USER_TYPES.INACTIVE) {
          result.inactiveUserTimeConditions = conditions?.map((condition) => {
            return {
              attributeType: condition.attributeType,
              value: condition.value,
              valueType: condition.valueType
            }
          })
        }

        result.list?.push(node)
      }
    })
  }
  return result
}

export const queryExternalUsers = (params: IPolicyAlertExternalUserParams): string => {
  const {
    page,
    pageSize = LIMIT_DEFAULT,
    datasourceId,
    alertId,
    subAlertAssignees = [],
    externalUser
  } = params

  const skip = calculateSkipAndLimit(page, pageSize)
  const id = alertId ? `, id: "${alertId}"` : ''
  const dataSourceId = datasourceId
    ? `datasourceIds: ${JSON.stringify([params?.datasourceId])}`
    : ''

  const filterSubAlertAssignees =
    subAlertAssignees?.length > 0 ? `, subAlertAssignees: ${JSON.stringify(subAlertAssignees)}` : ''

  const filterExternalUser =
    externalUser && externalUser.length > 0 ? `users: ${JSON.stringify(externalUser)}` : ''

  const externalUserFilter = `(${
    skip ? `skip: ${skip}, ` : ''
  }limit: ${pageSize}, ${filterExternalUser})`

  const externalUserCountFilter = filterExternalUser ? `(${filterExternalUser})` : ''

  return gql`
  {
    alert(${dataSourceId} ${id}, first: 1${filterSubAlertAssignees}) {
      edges {
        node {
          externalUserCount${externalUserCountFilter}
          externalUser${externalUserFilter} {
            user
            objectCount
          }
        }
      }
    }
  }
`
}

export const mapQueryExternalUsers = (
  raw: any
): {
  list: IPolicyAlertExternalUserGrouped[]
  total: number
} => {
  try {
    const total = raw?.alert?.edges[0]?.node?.externalUserCount || 0
    const list = raw?.alert?.edges[0]?.node?.externalUser ?? []

    return { list, total }
  } catch (e) {
    console.error(e)
    return { list: [], total: 0 }
  }
}

export const queryEntitiesImpacted = (params: IPolicyAlertEntitiesImpactedParams): string => {
  const { page, datasourceId, subAlertAssignees = [] } = params
  const cursor = getAfterCursor(page, LIMIT_DEFAULT)
  const dataSourceId = datasourceId ? `, datasourceIds: ${JSON.stringify([datasourceId])}` : ''

  const filterSubAlertAssignees =
    subAlertAssignees?.length > 0 ? `subAlertAssignees: ${JSON.stringify(subAlertAssignees)}` : ''

  return gql`
  {
    alert(first: 1, id: "${params[ALERT_ID]}" ${dataSourceId}, ${filterSubAlertAssignees}){
      edges{
        node{
          entityCount: entities {
            count
          }
          entities (first: ${LIMIT_DEFAULT}, after: "${cursor}") {
            edges {
              node {
                name
                id
                objects {
                  count
                }
                attributesCount
              }
            }
          }
        }
      }
    }
  }
`
}

export const mapQueryEntitiesImpacted = (
  raw: any
): { list: IPolicyAlertEntitiesImpacted[]; total: number } => {
  const total = raw?.alert?.edges[0]?.node?.entityCount?.count || 0
  const list = raw?.alert?.edges[0]?.node?.entities?.edges?.map(({ node: entity }) => ({
    entityId: entity?.id,
    entityName: entity?.name?.join(', '),
    objectsCount: entity?.objects?.count,
    attributesCount: entity?.attributesCount
  }))

  return { list, total }
}

export const queryRuleSetDetails = (params: AlertRuleSetDetailsParams): string => {
  const { subAlertAssignees = [], needsIncidentsCount = false, needsUsersCount = false } = params

  const id = params?.alertId ? `, id: "${params?.alertId}"` : ''
  const filterSubAlertAssignees =
    subAlertAssignees?.length > 0 ? `subAlertAssignees: ${JSON.stringify(subAlertAssignees)}` : ''
  const entitiesFragment = filterSubAlertAssignees
    ? ''
    : `entities {
      count
    }`

  /**
   * @todo use separate queries based on datasource type
   */

  const currentTime = Math.floor(Date.now() / 1000)
  const time2hAgo = currentTime - 2 * 60 * 60

  return gql`
  {
    channel(alertId: "${params?.alertId}" ${filterSubAlertAssignees}){
      count
    }
    alert(first: 1 ${id}, ${filterSubAlertAssignees}) {
      edges {
        node {
          id
          name
          status
          ${
            needsIncidentsCount
              ? `
          subAlerts(first: 1, dateFilter: {key: GENERATED_AT, start: ${time2hAgo}, end: ${currentTime}}) {
            count
          }`
              : ''
          }
          subAlertAssignees(limit: 2) {
            assignees
          }
          severity
          lastOccurred
          objectCount
          ${needsUsersCount ? 'userCount' : ''}
          mailCount
          ${entitiesFragment}
          actions {
            type
            comment
            updateTimestamp
            resolvedReason
            muteEndTime
            subAlertIds
          }
          datasource {
            edges {
              node {
                id
                type
                name
                createdBy
                policyActionConfiguration {
              actionType
              configuration {
                ... on PolicyActionArchiveConfigurationOutput {
                  archiveLocation
                  archiveMetadata {
                    archiveMode
                    targetDriveId
                    targetDriveName
                    targetSiteId
                    targetSiteName
                  }
                }
              }
            }
              }
            }
          }
          policy {
            edges {
              node {
                id
                description
                subAlertAssignmentStrategy {
                  globalStrategy
                }
                policyType {
                  edges {
                    node {
                      id
                      name
                      regulations
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
}
export const mapQueryRuleSetDetails = (raw: any) => {
  const alert = raw?.alert?.edges[0]?.node

  const archiveMetadata =
    alert?.datasource?.edges[0]?.node?.policyActionConfiguration?.[0]?.configuration
      ?.archiveMetadata

  const details: PoliciesState['ruleSetDetails'] = {
    id: alert?.id || '',
    name: alert?.name || '',
    status: alert?.status || '',
    assignees: alert?.subAlertAssignees?.assignees || [],
    incidentsCount: alert?.subAlerts?.count || 0,
    severity: alert?.severity || '',
    lastOccurred: alert?.lastOccurred || '',
    objectsCount: alert?.objectCount || 0,
    usersCount: alert?.userCount || 0,
    entitiesCount: alert?.entities?.count || 0,
    attributesCount: raw?.attributeInstance?.count || 0,
    actions: alert?.actions || [],
    dataSourceId: alert?.datasource?.edges[0]?.node?.id || '',
    dataSourceName: alert?.datasource?.edges[0]?.node?.name || '',
    dataSourceType: alert?.datasource?.edges[0]?.node?.type || '',
    dataSourceOwner: alert?.datasource?.edges[0]?.node?.createdBy,
    dataSourceArchiveLocation:
      alert?.datasource?.edges[0]?.node?.policyActionConfiguration?.[0]?.configuration
        ?.archiveLocation || '',
    dataSourceArchiveMetadata: {
      archiveMode: archiveMetadata?.archiveMode,
      targetDriveId: archiveMetadata?.targetDriveId,
      targetDriveName: archiveMetadata?.targetDriveName,
      targetSiteId: archiveMetadata?.targetSiteId,
      targetSiteName: archiveMetadata?.targetSiteName
    },
    policyName: alert?.policy?.edges[0]?.node?.policyType?.edges[0]?.node?.name || '',
    policyTypeId: alert?.policy?.edges[0]?.node?.policyType?.edges[0]?.node?.id || '',
    policyId: alert?.policy?.edges[0]?.node?.id || '',
    alertAssignment:
      alert?.policy?.edges[0]?.node?.subAlertAssignmentStrategy?.globalStrategy || '',
    regulations: alert?.policy?.edges[0]?.node?.policyType?.edges[0]?.node?.regulations || '',
    description: alert?.policy?.edges[0]?.node?.description || '',
    mailCount: alert?.mailCount || 0,
    channelsCount: raw?.channel?.count || 0
  }

  return details
}

export const queryRuleSetExternalUsersCount = (params: AlertRuleSetDetailsParams): string => {
  const { subAlertAssignees = [] } = params
  const id = params?.alertId ? `, id: "${params?.alertId}"` : ''
  const filterSubAlertAssignees =
    subAlertAssignees?.length > 0 ? `subAlertAssignees: ${JSON.stringify(subAlertAssignees)}` : ''

  return gql`
  {
    alert(first: 1 ${id}, ${filterSubAlertAssignees}) {
      edges {
        node {
          externalUserCount
        }
      }
    }
  }
`
}
export const mapQueryRuleSetExternalUsersCount = (raw: any): number => {
  return raw?.alert?.edges[0]?.node?.externalUserCount || 0
}

export const queryAlertAuditLogs = (params: AlertAuditLogsParams): string => {
  const { alertId, triggeredBy } = params

  let filter = ''
  if (triggeredBy) {
    filter = `(filter: {key: TRIGGERED_BY, values: ["${triggeredBy}"]})`
  }
  return gql`
    {
      alert(first: 1, id: "${alertId}") {
        edges {
          node {
            id
            approvalCount
            history${filter} {
              edges {
                node {
                  id
                  action
                  triggeredBy
                  comment
                  completionTimestamp
                  triggeredTimestamp
                  numObjectsPending
                  numObjectsComplete
                  approvalDetails {
                        approvalStatus
                        approvalAction
                  }
                  actionMetadata {
                    ... on ChangeStateActionOutput {
                      newState
                    }
                  }
                  config {
                    ... on ReassignConfig {
                      newAssignee
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}
export const mapQueryAlertAuditLogs = (raw: any): AlertAuditLog[] => {
  // todo: change to approvalCount
  const pendingApprovalCounts = raw?.alert?.edges[0]?.node?.approvalCount || 0
  const list = raw?.alert?.edges[0]?.node?.history?.edges?.map(({ node: log }) => ({
    id: log?.id,
    action: log?.action,
    triggeredBy: log?.triggeredBy,
    comment: log?.comment || '',
    completionTimestamp: log?.completionTimestamp || '',
    triggeredTimestamp: log?.triggeredTimestamp || '',
    numObjectsPending: log?.numObjectsPending || 0,
    numObjectsComplete: log?.numObjectsComplete || 0,
    newAssignee: log?.newAssignee,
    muteTillTimestamp: log?.muteTillTimestamp,
    actionState: log?.actionMetadata?.newState,
    pendingApprovalCounts: pendingApprovalCounts,
    approvalDetails: log?.approvalDetails
  }))

  return list
}

export const queryAlertAuditLogDetails = (params: AlertAuditLogDetailsParams): string => {
  const { alertId, auditLogId, policyType } = params
  const cursor = getAfterCursor(Number(params?.page), AUDIT_LOG_OBJECTS_LIMIT_DEFAULT)

  const isPolicyUserBased = [POLICY_TYPES.RANSOMWARE_ACTIVITY, POLICY_TYPES.USERS].includes(
    policyType
  )

  // For Ransomware policy type
  const usersFragment = `
    users {
      edges {
        node {
          id
          name
          email
          departmentName
          employeeType
        }
      }
    }
  `

  // For other policy types
  const objectsFragment = `
    objects(first: 1) {
      edges {
        node {
          id
          name
          owner
          riskScore
          datasource {
            edges {
              node {
                type
              }
            }
          }
          auditAttributeData {
            attributes {
              internalName
              name
            }
            count
          }
          classification
          objectLink
          drive {
            edges {
              node {
                driveName
              }
            }
          }
          entity {
            count
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  `

  return gql`
    {
      alert(first: 1, id: "${alertId}") {
        edges {
          node {
            id
            history(first: 1, id: "${auditLogId}") {
              edges {
                node {
                  id
                  action
                  triggeredBy
                  comment
                  triggeredTimestamp
                  completionTimestamp
                  numObjectsComplete
                  approvalDetails {
                        approvalStatus
                        approvalAction
                  }
                  config {
                    ... on ReassignConfig {
                      newAssignee
                    }
                    ... on MuteConfig {
                      muteTillTimestamp
                    }
                  }
                  actionMetadata {
                    ... on PolicyActionConfigurationOutput {
                      actionType
                      configuration {
                        ... on PolicyActionArchiveConfigurationOutput {
                          archiveLocation
                        }
                      }
                    }
                    ... on ChangeStateActionOutput {
                      newState
                    }
                  }
                  subAlertHistory(first: ${AUDIT_LOG_OBJECTS_LIMIT_DEFAULT}, after: "${cursor}") {
                    count
                    edges {
                      node {
                        updateTimestamp
                        subAlertId
                        workflowId
                        ${isPolicyUserBased ? usersFragment : objectsFragment}
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}
export interface AlertAuditLogUsersList {
  id: string
  name?: string
  email?: string
  employeeType?: AlertEmployeeType
  updateTimestamp?: string
  departmentName?: string
  workflowId?: string
  subAlertId?: string
}
export const mapQueryAlertAuditLogDetails = (raw: any): AlertAuditLog => {
  const auditLog = raw?.alert?.edges[0]?.node?.history?.edges[0]?.node

  const objectsList = auditLog?.subAlertHistory?.edges?.map((subAlert) => {
    const obj = subAlert?.node?.objects?.edges[0]?.node
    return {
      id: obj?.id,
      name: obj?.name,
      owner: obj?.owner,
      classification: obj?.classification,
      objectLink: obj?.objectLink,
      updateTimestamp: subAlert?.node?.updateTimestamp,
      attributes: obj?.auditAttributeData?.attributes?.map((attr) => attr),
      datasourceType: obj?.datasource?.edges?.[0]?.node?.type,
      entities: obj?.entity?.edges?.map((entity) => entity?.node),
      workflowId: subAlert?.node?.workflowId,
      subAlertId: subAlert?.node?.subAlertId,
      riskScore: obj?.riskScore
    }
  })

  const usersList: AlertAuditLogUsersList[] = auditLog?.subAlertHistory?.edges?.map((subAlert) => {
    const user = subAlert?.node?.users?.edges[0]?.node
    return {
      id: user?.id,
      name: user?.name || '',
      email: user?.email || '',
      departmentName: user?.departmentName || '',
      workflowId: subAlert?.node?.workflowId,
      subAlertId: subAlert?.node?.subAlertId,
      updateTimestamp: subAlert?.node?.updateTimestamp
    }
  })

  return {
    id: auditLog?.id,
    action: auditLog?.action,
    triggeredBy: auditLog?.triggeredBy,
    comment: auditLog?.comment || '',
    completionTimestamp: auditLog?.completionTimestamp || '',
    triggeredTimestamp: auditLog?.triggeredTimestamp || '',
    numObjectsPending: auditLog?.numObjectsPending || 0,
    numObjectsComplete: auditLog?.numObjectsComplete || 0,
    totalObjects: auditLog?.subAlertHistory?.count,
    newAssignee: auditLog?.config?.newAssignee,
    archivalLocation: auditLog?.actionMetadata?.configuration?.archiveLocation,
    muteTillTimestamp: auditLog?.config?.muteTillTimestamp,
    objectsList: objectsList,
    actionState: auditLog?.actionMetadata?.newState,
    usersList: usersList,
    approvalDetails: auditLog?.approvalDetails
  }
}

export const queryAuditLogActionHistory = (params: AlertAuditLogActionHistoryParams): any => {
  return gql`
    query subAlertHistoryData {
      subAlertHistory(
        first: ${params?.page * LIMIT_DEFAULT}
        subAlertIds: ["${params?.subAlertId}"]
        anchor: { anchorWorkflowId: "${params?.anchorWorkflowId}", nearestNeighbours: ${
    params?.nearestNeighbours
  } }
      ) {
        edges {
          node {
            subAlertId
            workflowId
            alertHistory {
              edges {
                node {
                  id
                  triggeredTimestamp
                  triggeredBy
                  action
                  approvalDetails {
                    approvalAction
                    approvalStatus
                  }
                  comment
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapAuditLogActionHistory = (raw: any): AuditLogActionHistory | undefined => {
  const { edges } = raw?.subAlertHistory

  const items: any[] = []
  if (edges?.length) {
    edges?.forEach((edge) => {
      const { node = {} } = edge || {}
      items.push({
        ...node?.alertHistory?.edges[0]?.node,
        subAlertId: node?.subAlertId,
        workflowId: node?.workflowId
      })
    })

    return {
      alertHistory: items as any[]
    }
  }
  return
}

// sub alert actions
const mapAlertActionFilters = (params: AlertActionParams | SubAlertsActionParams): string => {
  const isObjects = Object.keys(params?.documentFilters || {})?.length
  const isMails = Object.keys(params?.mailFilters || {})?.length

  if (!isObjects && !isMails) return ''

  const getObjectFilters = () => {
    const data = params.documentFilters as AlertActionDocumentFilterParams
    const riskScores = data.riskScores
      ? `riskScores: { min: ${data.riskScores.min}, max: ${data.riskScores.max} }`
      : ''
    const lastModifiedTimestamp = data.lastModifiedTimestamp
      ? `lastModifiedTimestamp: { min: ${data.lastModifiedTimestamp.min}, max: ${data.lastModifiedTimestamp.max} }`
      : ''
    const labelIds = data.labelIds ? `labelIds: ${JSON.stringify(data.labelIds)}` : ''
    const classification = data.classification
      ? `classification: ${JSON.stringify(data.classification)}`
      : ''
    const owners = data.owners ? `owners: ${JSON.stringify(data.owners)}` : ''
    const sharedWith = data.sharedWith ? `sharedWith: ${JSON.stringify(data.sharedWith)}` : ''
    const attributeIds = data.attributeIds
      ? `attributeIds: ${JSON.stringify(data.attributeIds)}`
      : ''
    const templateIds = data.templateIds ? `templateIds: ${JSON.stringify(data.templateIds)}` : ''
    const sensitivity = data.sensitivity ? `sensitivity: [${data.sensitivity}]` : ''
    const state = data.state ? `state: [${data.state}]` : ''

    return gql`documentFilters: {
      ${riskScores}
      ${lastModifiedTimestamp}
      ${labelIds}
      ${classification}
      ${owners}
      ${sharedWith}
      ${attributeIds}
      ${templateIds}
      ${sensitivity}
      ${state}
    }`
  }

  const getMailFilters = () => {
    const data = params.mailFilters as AlertActionMailFilterParams

    const attributeIds = data.attributeIds
      ? `attributeIds: ${JSON.stringify(data.attributeIds)}`
      : ''
    const senders = data.senders ? `senders: ${JSON.stringify(data.senders)}` : ''
    const recipients = data.recipients ? `recipients: ${JSON.stringify(data.recipients)}` : ''
    const sensitivity = data.sensitivity ? `sensitivity: [${data.sensitivity}]` : ''
    const type = data.type ? `type: ${data.type}` : ''

    return gql`mailFilters: {
      ${attributeIds}
      ${senders}
      ${recipients}
      ${sensitivity}
      ${type}
    }`
  }

  return isObjects ? getObjectFilters() : getMailFilters()
}

export const queryResolveAlert = (params: AlertActionParams): any => {
  let filterQuery = `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
    mutation {
      resolveSubAlert(
        actionInput: {
          clientMutationId: "1"
          alertId: "${params?.alertIds[0]}"
          triggeredBy: "${params?.triggeredBy}"
          comment: "${escapeNewlineandTab(params?.comment || '')}"
          subAlertStates: [${params.subAlertStates}]
          assignees: ${JSON.stringify(params.assignees || [])}
          ${filterQuery}
        }
      ) { status }
    }
  `
}
export const queryChangeStateForSubAlert = (params: AlertActionParams): any => {
  let filterQuery = `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
    mutation {
      changeStateSubAlert(
        actionInput: {
          clientMutationId: "1"
          alertId: "${params?.alertIds[0]}"
          triggeredBy: "${params?.triggeredBy}"
          comment: "${escapeNewlineandTab(params?.comment || '')}"
          newState: ${params?.actionState}
          subAlertStates: [${params.subAlertStates}]
          assignees: ${JSON.stringify(params.assignees || [])}
          ${filterQuery}
        }
      ) { status }
    }
  `
}
export const queryReassignAlert = (params: AlertActionParams): any => {
  let filterQuery = `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
      mutation {
        reassignSubAlert(
          actionInput: {
            clientMutationId: "1"
            alertId: "${params?.alertIds[0]}"
            triggeredBy: "${params?.triggeredBy}"
            comment: "${escapeNewlineandTab(params?.comment || '')}"
            ${params?.newAssignee ? `newAssignee: "${params?.newAssignee || ''}"` : ''}
            ${
              params?.subAlertAssignmentStrategy
                ? `subAlertAssignmentStrategy: {globalStrategy: ${params?.subAlertAssignmentStrategy}}`
                : ''
            }
            subAlertStates: [${params.subAlertStates}]
            assignees: ${JSON.stringify(params.assignees || [])}
            ${filterQuery}
          }
        ) { status }
      }
    `
}
export const queryNoScanAlert = (params: AlertActionParams): any => {
  const folderIdsFragment = params?.folderIds?.length
    ? `folderIds: ${JSON.stringify(params?.folderIds || [])}`
    : ''

  const subAlertIdsFragment = params?.subAlertIds?.length
    ? `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
    : ''

  let filterQuery = [folderIdsFragment, subAlertIdsFragment].filter(Boolean).join(',')
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
      mutation {
        noScanSubAlert(
          actionInput: {
            clientMutationId: "1"
            alertId: "${params?.alertIds[0]}"
            triggeredBy: "${params?.triggeredBy}"
            comment: "${escapeNewlineandTab(params?.comment || '')}"
            subAlertStates: [${params.subAlertStates}]
            assignees: ${JSON.stringify(params.assignees || [])}
            ${filterQuery}
          }
        ) { status }
      }
    `
}
export const queryPermitAlert = (params: AlertActionParams): any => {
  const folderIdsFragment = params?.folderIds?.length
    ? `folderIds: ${JSON.stringify(params?.folderIds || [])}`
    : ''

  const subAlertIdsFragment = params?.subAlertIds?.length
    ? `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
    : ''

  let filterQuery = [folderIdsFragment, subAlertIdsFragment].filter(Boolean).join(',')
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
    mutation {
      permitSubAlert(
        actionInput: {
          clientMutationId: "1"
          alertId: "${params?.alertIds[0]}"
          triggeredBy: "${params?.triggeredBy}"
          comment: "${escapeNewlineandTab(params?.comment || '')}"
          subAlertStates: [${params.subAlertStates}]
          assignees: ${JSON.stringify(params.assignees || [])}
          ${filterQuery}
        }
      ) {
        status
      }
    }
  `
}
export const queryMuteAlert = (params: AlertActionParams): any => {
  let filterQuery = `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
    mutation {
      muteSubAlert(
        actionInput: {
          clientMutationId: "1"
          alertId: "${params?.alertIds[0]}"
          triggeredBy: "${params?.triggeredBy}"
          comment: "${escapeNewlineandTab(params?.comment || '')}"
          muteTillTimestamp: "${params?.muteTillTimestamp}"
          subAlertStates: [${params.subAlertStates}]
          assignees: ${JSON.stringify(params.assignees || [])}
          ${filterQuery}
        }
      ) { status }
    }
  `
}
export const queryUnmuteAlert = (params: AlertActionParams): any => {
  let filterQuery = `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
    mutation {
      unmuteSubAlert(
        actionInput: {
          clientMutationId: "1"
          alertId: "${params?.alertIds[0]}"
          triggeredBy: "${params?.triggeredBy}"
          comment: "${escapeNewlineandTab(params?.comment || '')}"
          subAlertStates: [${params.subAlertStates}]
          assignees: ${JSON.stringify(params.assignees || [])}
          ${filterQuery}
        }
      ) { status }
    }
  `
}
export const queryDeleteAlertObject = (params: AlertActionParams): any => {
  const folderIdsFragment = params?.folderIds?.length
    ? `folderIds: ${JSON.stringify(params?.folderIds || [])}`
    : ''

  const subAlertIdsFragment = params?.subAlertIds?.length
    ? `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
    : ''

  let filterQuery = [folderIdsFragment, subAlertIdsFragment].filter(Boolean).join(',')
  if (params.isBulkSelection) {
    const bulkFilterQuery = mapAlertActionFilters(params)
    const parts = [folderIdsFragment, bulkFilterQuery].filter(Boolean)
    filterQuery = parts.join('').replace(/,\s*$/, '')
  }

  return gql`
    mutation {
      deleteSubAlertObject(
        actionInput: {
          clientMutationId: "1"
          alertId: "${params?.alertIds[0]}"
          triggeredBy: "${params?.triggeredBy}"
          comment: "${escapeNewlineandTab(params?.comment || '')}"
          subAlertStates: [${params.subAlertStates}]
          assignees: ${JSON.stringify(params.assignees || [])}
          ${filterQuery}
        }
      ) { status }
    }
  `
}

export const queryReassignObjectOwner = (params: AlertActionParams): any => {
  const subAlertIdsFragment = params?.subAlertIds?.length
    ? `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
    : ''
  const reassignModeFragment = params?.reassignMode ? `mode: ${params?.reassignMode}` : ''
  const fallbackUserFragment = params?.fallbackUser ? `user: "${params.fallbackUser}"` : ''

  const filterQuery = [subAlertIdsFragment, reassignModeFragment, fallbackUserFragment]
    .filter(Boolean)
    .join(',')

  return gql`
    mutation reassign_objects {
      reassignObjects(
        actionInput: {
          clientMutationId: "1"
          alertId: "${params?.alertIds[0]}"
          triggeredBy: "${params?.triggeredBy}"
          ${filterQuery}
        }
      ) { status }
    }
  `
}

const getRevokeAccesActionFragment = (revokeAccessType: OBJECT_REVOKE_ACCESS_TYPES): string => {
  const mapRevokeAccessTypeToApiParam = {
    [OBJECT_REVOKE_ACCESS_TYPES.all]: OBJECT_REVOKE_ACCESS_TYPES.all,
    [OBJECT_REVOKE_ACCESS_TYPES.allWrite]: OBJECT_REVOKE_ACCESS_TYPES.all,
    [OBJECT_REVOKE_ACCESS_TYPES.external]: OBJECT_REVOKE_ACCESS_TYPES.external,
    [OBJECT_REVOKE_ACCESS_TYPES.externalWrite]: OBJECT_REVOKE_ACCESS_TYPES.external,
    [OBJECT_REVOKE_ACCESS_TYPES.link]: OBJECT_REVOKE_ACCESS_TYPES.link
  }
  const getRevokeAccessArgParams = {
    [OBJECT_REVOKE_ACCESS_TYPES.all]: '',
    [OBJECT_REVOKE_ACCESS_TYPES.allWrite]: `
      revokeAllAccessArgs: {
        accessPermissions: [WRITE]
      }
    `,
    [OBJECT_REVOKE_ACCESS_TYPES.external]: '',
    [OBJECT_REVOKE_ACCESS_TYPES.externalWrite]: `
      revokeExternalAccessArgs: {
        accessPermissions: [WRITE]
      }
    `,
    [OBJECT_REVOKE_ACCESS_TYPES.link]: ''
  }
  return gql`
    revokeAccessAction: {
      revokeAccessType: ${mapRevokeAccessTypeToApiParam[revokeAccessType]}
      subAlertActionType: RESOLVE
      ${getRevokeAccessArgParams[revokeAccessType]}
    }
  `
}

export const mutationRevokeObjectAccess = (params: AlertActionParams): any => {
  let filterQuery = `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
    mutation revoke {
      revokeObjectAccess(
        actionInput: {
          clientMutationId: "1"
          alertId: "${params?.alertIds[0]}"
          triggeredBy: "${params?.triggeredBy}"
          ${getRevokeAccesActionFragment(params?.revokeAccessType as OBJECT_REVOKE_ACCESS_TYPES)}
          subAlertStates: [${params.subAlertStates}]
          assignees: ${JSON.stringify(params.assignees || [])}
          ${filterQuery}
        }
      ) {
        clientMutationId
        status
      }
    }
  `
}

export const mutationArchiveSubAlerts = (params: SubAlertsActionParams): any => {
  let filterQuery = `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
    mutation archiveObject {
      archiveSubAlertObject(actionInput: {
        clientMutationId: "1",
        alertId: "${params?.alertId}",
        triggeredBy: "${params?.triggeredBy}",
        comment: "${escapeNewlineandTab(params?.comment || '')}"
        ${params.subAlertStates?.length ? `subAlertStates: [${params.subAlertStates}]` : ''}
        assignees: ${JSON.stringify(params.assignees || [])}
        ${filterQuery}
      }) {
        clientMutationId
        status
      }
    }
  `
}

export const mutationApplySubAlertLegalHold = (params: ApplySubAlertActionParams): any => {
  let filterQuery = `subAlertIds: ${JSON.stringify(params?.subAlertIds || [])}`
  if (params.isBulkSelection) {
    filterQuery = mapAlertActionFilters(params)
  }

  return gql`
    mutation applyLegalHold {
      applyLegalHold(actionInput: {
        clientMutationId: "1",
        alertId: "${params?.alertId}",
        triggeredBy: "${params?.triggeredBy}",
        comment: "${params?.comment}",
        muteTillTimestamp: "${params?.muteTillTimestamp}"
        subAlertStates: [${params.subAlertStates}]
        assignees: ${JSON.stringify(params.assignees || [])}
        ${filterQuery}
      }) {
        clientMutationId
        status
      }
    }
  `
}

export const queryMailboxFilterValues = (datasourceId: string): string => {
  return gql`{
    members(filter: [{key: DATASOURCE_IDS, values: ["${datasourceId}"]}, {key: MEMBER_TYPE, values: ["INTERNAL"]}]) {
      edges {
        node {
          email
        }
      }
    }
  }
  `
}

export const mapQueryMailboxFilterValues = (raw: any): { list: string[] } => {
  let list = []
  if (raw && raw?.members) {
    if (raw?.members?.edges && Array?.isArray(raw?.members?.edges)) {
      list = raw?.members?.edges?.map(({ node: { email } }) => email)
    }
  }

  return { list }
}

export const queryAlertObjectsImpacted = (params: IAlertObjectsImpactedParams): string => {
  const {
    page,
    pageSize = LIMIT_DEFAULT,
    datasourceId,
    datasourceType,
    alertId,
    subAlertAssignees = [],
    mailboxFolderType,
    mailbox,
    actionState
  } = params

  const cursor = getAfterCursor(page, pageSize)

  const id = alertId ? `, id: "${alertId}"` : ''
  const dataSourceId = datasourceId
    ? `, datasourceIds: ${JSON.stringify([params?.datasourceId])}`
    : ''

  const filterSubAlertAssignees =
    subAlertAssignees?.length > 0 ? `subAlertAssignees: ${JSON.stringify(subAlertAssignees)}` : ''
  const filterAssignee =
    subAlertAssignees?.length > 0 ? `assignees: ${JSON.stringify(subAlertAssignees)}` : ''

  const filterMailboxFolderTpe = mailboxFolderType
    ? `{
      key:MAIL_FOLDER_TYPE,
      values: ${JSON.stringify(mailboxFolderType)}
      }`
    : ''

  const filterMailbox = mailbox?.length
    ? `{
      key:MAILBOX,
      values: ${JSON.stringify(mailbox)}
      }`
    : ''

  const filterActionState = actionState?.length
    ? `{
      key:STATE,
      values: ${JSON.stringify(actionState.map((val) => ExtendedSubAlertActionStateFilter[val]))}
      }`
    : ''

  const isTickets = datasourceType === DATA_SOURCE_TYPES?.jira
  const isMails = MAIL_DATASOURCES?.find((type) => type == datasourceType)
  const isChannels =
    datasourceType === DATA_SOURCE_TYPES?.slack || datasourceType === DATA_SOURCE_TYPES?.teams
  const isGeneric = datasourceType === DATA_SOURCE_TYPES?.generic

  const FRAGMENT_TICKETS = `
    ticket {
      count
      edges {
        node {
          id
          ticketId
          ticketName
          lastModifiedTime
          ticketLink
          reporter {
            name
          }
          assignee {
            name
          }
          ticketStoreProject(first: 1) {
            edges {
              node {
                id
                projectName
              }
            }
          }
          hasAttachments
          attachments {
            id
            name
            type
          }
        }
      }
    }`

  const FRAGMENT_MAILS = `
    mail {
      count
      edges{
        node{
          id
          type
          refMailboxIds
          messageId
          timestamp
          subject
          sender {
            email
          }
          recipients {
            email
          }
          attachments: objects(category: FILE) {
            edges {
              node {
                id
                name
                type
              }
            }
          }
        }
      }
    }`

  const FRAGMENT_CHANNELS = `
    channels {
      count
      edges {
        node {
          channelId
          channelName
          piiConversationsCount
          membersCount
          type
        }
      }
    }`

  const FRAGMENT_PROJECTS = `
    project {
      edges{
        node {
          name
        }
      }
    }`

  const FRAGMENT_ACCESS_CONTROL = `
      userAccess {
        count
        edges {
          node {
            id
            name
          }
        }
      }
      writeAccess: userAccess(accessModes: [${AccessControlAccessMode.Write}]) {
        count
        edges {
          node {
            id
            name
          }
        }
      }
      readAccess: userAccess(accessModes: [${AccessControlAccessMode.Read}]) {
        count
        edges {
          node {
            id
            name
          }
        }
      }
      groupAccess {
        count
        edges {
          node {
            id
            name
          }
        }
      }
    `

  const isPolicyAccessControl = params?.policyType === POLICY_TYPES.ACCESS_POLICY

  return gql`
  {
    alert(${dataSourceId} ${id}, first: 1, ${filterSubAlertAssignees}) {
      edges {
        node {
          datasource {
            edges {
              node {
                id
                type
              }
            }
          }
          subAlerts(
            first: ${pageSize},
            after: "${cursor}",
            filter:[{
              key:${API_FILTER_ALERTS.STATUS},
              values:["${ALERT_STATUS_API_MAP[ALERT_STATUS.active]}"]
            }, ${filterMailboxFolderTpe}, ${filterMailbox}, ${filterActionState}],
            ${filterAssignee}
          ) {
            count
            edges {
              node {
                id
                assignee
                generatedAt
                state
                ${isChannels ? FRAGMENT_CHANNELS : ''}
                objects(first: 1) {
                  edges {
                    node {
                      id
                      name
                      owner
                      lastModifiedTime
                      riskScore
                      folder {
                        id
                        path
                        name
                        webUrl
                      }
                      entity {
                        count
                      }
                      attribute {
                        count
                      }
                      ${isPolicyAccessControl ? FRAGMENT_ACCESS_CONTROL : ''}
                      ${isTickets ? FRAGMENT_TICKETS : ''}
                      ${isMails ? FRAGMENT_MAILS : ''}
                      ${isGeneric ? FRAGMENT_PROJECTS : ''}
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
}
export const mapQueryAlertObjectsImpacted = (
  raw: any
): { list: IAlertObjectsImpacted[]; total: number } => {
  try {
    const list = raw?.alert?.edges[0]?.node?.subAlerts?.edges?.map(({ node: subAlert }) => {
      const groupsList =
        subAlert?.objects?.edges[0]?.node?.groupAccess?.edges?.map(({ node }) => ({
          id: node?.id,
          name: node?.name
        })) || []

      const usersList =
        subAlert?.objects?.edges[0]?.node?.userAccess?.edges?.map(({ node }) => ({
          id: node?.id,
          name: node?.name
        })) || []
      const writeAccess =
        subAlert?.objects?.edges[0]?.node?.writeAccess?.edges?.map(({ node }) => ({
          id: node?.id,
          name: node?.name
        })) || []

      const readAccess = subAlert?.objects?.edges[0]?.node?.readAccess?.edges?.map(({ node }) => ({
        id: node?.id,
        name: node?.name
      }))

      const bucket = subAlert?.objects?.edges[0]?.node?.bucket?.edges[0]?.node
      const ticket = subAlert?.objects?.edges[0]?.node?.ticket?.edges[0]?.node
      const mail = subAlert?.objects?.edges[0]?.node?.mail?.edges[0]?.node
      const channel = subAlert?.channels?.edges[0]?.node
      const project = subAlert?.objects?.edges[0]?.node?.project?.edges[0]?.node

      let attachments = []
      if (ticket) {
        attachments = ticket?.attachments
      }
      if (mail) {
        attachments = mail?.attachments?.edges?.map(({ node }) => node) || []
      }

      const result: IAlertObjectsImpacted = {
        id: subAlert?.id,
        assignee: subAlert?.assignee || '',
        generatedAt: subAlert?.generatedAt || '',
        dataSourceId: raw?.alert?.edges[0]?.node?.datasource?.edges[0]?.node?.id || '',
        documentId: subAlert?.objects?.edges[0]?.node?.id || '',
        documentName: subAlert?.objects?.edges[0]?.node?.name || '',
        attributesCount: subAlert?.objects?.edges[0]?.node?.attribute?.count,
        entitiesCount: subAlert?.objects?.edges[0]?.node?.entity?.count,
        groupsList,
        usersList,
        readAccessList: readAccess,
        writeAccessList: writeAccess,
        createdBy: subAlert?.objects?.edges[0]?.node?.owner || '',
        lastModified: subAlert?.objects?.edges[0]?.node?.lastModifiedTime || null,
        owner: subAlert?.objects?.edges[0]?.node?.owner || '',
        folder: subAlert?.objects?.edges[0]?.node?.folder || {},
        riskScore: subAlert?.objects?.edges[0]?.node?.riskScore || null,
        // common fields
        sharedOn: mail ? mail?.timestamp : ticket ? ticket?.lastModifiedTime : '',
        attachments,
        messageId: mail?.messageId,
        // buckets
        bucketName: bucket?.displayName || bucket?.name || '',
        bucketOwner: bucket?.ownerName || '',
        // tickets
        jiraTicketId: ticket?.ticketId || '',
        ticketId: ticket?.id || '',
        ticketName: ticket?.ticketName || '',
        ticketLink: ticket?.ticketLink || '',
        ticketReporter: ticket?.reporter?.name || '',
        ticketAssignee: ticket?.assignee?.name || '',
        projectName: (ticket || project)?.ticketStoreProject?.edges[0]?.node?.projectName || '',
        projectId: (ticket || project)?.ticketStoreProject?.edges[0]?.node?.id || '',
        // emails
        mailSubject: mail?.subject,
        mailFrom: mail?.sender?.email || '',
        mailTo: mail?.recipients?.map(({ email }) => email),
        type: mail?.type || '',
        refMailboxIds: mail?.refMailboxIds || [],
        // channels
        channelId: channel?.channelId || '',
        channelName: channel?.channelName || '',
        channelPiiCount: channel?.piiConversationsCount || 0,
        channelMembersCount: channel?.membersCount || 0,
        channelType: channel?.type,
        // access control
        users: subAlert?.objects?.edges[0]?.node?.userAccess?.edges?.map(({ node }) => node) || [],
        groups:
          subAlert?.objects?.edges[0]?.node?.groupAccess?.edges?.map(({ node }) => node) || [],
        userAccessCount: subAlert?.objects?.edges[0]?.node?.userAccess?.count || 0,
        groupAccessCount: subAlert?.objects?.edges[0]?.node?.groupAccess?.count || 0,
        actionState: subAlert?.state
      }

      return result
    })
    return { list, total: raw?.alert?.edges[0]?.node?.subAlerts?.count }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const queryExtendedAlertObjectsImpacted = (
  params: FetchExtendedObjectsImpactedParams
): string => {
  const { alertId, subAlertId, datasourceId } = params

  return gql`
    {
      alert(
        id: "${alertId}"
        ${datasourceId ? `datasourceIds: ["${datasourceId}"]` : ''}
        first: 1
      ) {
        edges {
          node {
            subAlerts(
              first: 1
              id: "${subAlertId}"
            ) {
              edges {
                node {
                  id
                  objects(first: 1) {
                    edges {
                      node {
                        classification
                        createdAt
                        attribute {
                          edges {
                            node {
                              name
                              internalName
                            }
                          }
                        }
                        entity {
                          edges {
                            node {
                              id
                              name
                            }
                          }
                        }
                        labels {
                          edges {
                            node {
                              id
                              name
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapExtendedAlertObjectsImpacted = (
  raw: any,
  alertId: string
): ExtendedAlertObjectsImpacted => {
  const subAlertEdges = raw?.alert?.edges[0]?.node?.subAlerts?.edges ?? []
  const subAlert = subAlertEdges.length > 0 ? subAlertEdges[0].node : undefined

  const attributesList =
    subAlert?.objects?.edges[0]?.node?.attribute?.edges?.map(({ node: attr }) => ({
      name: attr?.name,
      internalName: attr?.internalName
    })) || []

  const entitiesList =
    subAlert?.objects?.edges[0]?.node?.entity?.edges
      ?.filter(({ node }) => !!node?.name)
      ?.map(({ node }) => ({
        id: node?.id,
        name: Array?.isArray(node?.name) ? node?.name[0] : node?.name
      })) || []
  const classification = subAlert?.objects?.edges[0]?.node?.classification || null
  const labels = subAlert?.objects?.edges[0]?.node?.labels?.edges?.map(({ node }) => node) || []

  return {
    alertId,
    createdAt: subAlert?.objects?.edges[0]?.node?.createdAt,
    subAlertId: subAlert.id,
    labels,
    attributesList,
    entitiesList,
    classification
  }
}

export const queryGenericObjectsImpacted = (params: ObjectsImpactedGenericParams): string => {
  const {
    page,
    pageSize = LIMIT_DEFAULT,
    datasourceType,
    policyType,
    sortBy,
    sortOrder,
    alertId,
    datasourceId,
    filters
  } = params

  const cursor = getAfterCursor(page, pageSize)

  const combinedFilters = [...(filters?.filter ?? []), ...(filters?.subAlertFilter ?? [])]

  const { intRangeFilter } = getObjectsImpactedFilters(params)

  const dateFilters = filters?.dateFilters ?? []
  const dateFilter = dateFilters.length > 0 ? dateFilters[0] : undefined
  const dateFilterString = dateFilter
    ? `dateFilter: {
      key: ${dateFilter.key}, start: ${dateFilter.start}, end: ${dateFilter.end}
    }`
    : ''

  const isPolicyAccessControl = policyType === POLICY_TYPES.ACCESS_POLICY
  const isGeneric = datasourceType === DATA_SOURCE_TYPES?.generic
  const isSmb = datasourceType === DATA_SOURCE_TYPES?.smb
  const isBuckets = BUCKET_DATASOURCES.includes(datasourceType)

  const FRAGMENT_FILESHARE = `
    fileShare {
      edges {
        node {
          id
          name
        }
      }
    }`

  const FRAGMENT_PROJECTS = `
    project {
      edges{
        node {
          id
          name
        }
      }
    }`

  const FRAGMENT_ACCESS_CONTROL = `
      userAccess {
        count
        edges {
          node {
            id
            name
          }
        }
      }
      writeAccess: userAccess(accessModes: [${AccessControlAccessMode.Write}]) {
        count
        edges {
          node {
            id
            name
          }
        }
      }
      readAccess: userAccess(accessModes: [${AccessControlAccessMode.Read}]) {
        count
        edges {
          node {
            id
            name
          }
        }
      }
      groupAccess {
        count
        edges {
          node {
            id
            name
          }
        }
      }
    `

  const FRAGMENT_BUCKETS = `
    bucket {
      edges{
        node{
          name
          displayName
          ownerName
        }
      }
    }`

  return gql`
  {
    alert(
      datasourceIds: ["${datasourceId}"]
      id: "${alertId}"
      first: 1
    ) {
      edges {
        node {
          objectCount
          subAlerts(
            first: ${pageSize}
            after: "${cursor}"
            ${sortBy ? `sortField: ${sortBy}` : ''}
            ${sortBy ? `sortByAsc: ${sortOrder == 1 ? 'true' : 'false'}` : ''}
            ${
              combinedFilters.length ? `filter: ${parameterizeArrayofObjects(combinedFilters)}` : ''
            }
            ${intRangeFilter}
            ${dateFilterString}
          ) {
            edges {
              node {
                id
                assignee
                generatedAt
                state
                lastAccessTime
                approvalDetails {
                  approvalStatus
                  approvalRequestAlertHistoryId
                  approvalRequestAlertHistory {
                    edges {
                      node {
                        id
                        action
                        triggeredBy
                        triggeredTimestamp
                        actionMetadata {
                          ... on ChangeStateActionOutput {
                            newState
                          }
                        }
                        approvalDetails {
                          approvalStatus
                          approverGroups
                          additionalApprovers
                        }
                      }
                    }
                  }
                  approvalResponseAlertHistory {
                    edges {
                      node {
                        id
                        action
                        triggeredBy
                        triggeredTimestamp
                        actionMetadata {
                          ... on ChangeStateActionOutput {
                            newState
                          }
                        }
                        comment
                      }
                    }
                  }
                }
                objects(first: 1) {
                  edges {
                    node {
                      id
                      name
                      owner
                      lastModifiedTime
                      riskScore
                      folder {
                        id
                        path
                        name
                        webUrl
                      }
                      template {
                        edges {
                          node {
                            id
                            templateName
                          }
                        }
                      }
                      attribute {
                        count
                        edges {
                          node {
                            name
                            internalName
                          }
                        }
                      }
                      ${isPolicyAccessControl ? FRAGMENT_ACCESS_CONTROL : ''}
                      ${isGeneric ? FRAGMENT_PROJECTS : ''}
                      ${isSmb ? FRAGMENT_FILESHARE : ''}
                      ${isBuckets ? FRAGMENT_BUCKETS : ''}
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
}
export const mapQueryGenericObjectsImpacted = (
  raw: any
): { list: IAlertObjectsImpacted[]; objectCount: number } => {
  try {
    const tooltipActions = [
      ALERT_ACTIONS.resolve,
      ALERT_ACTIONS.reassign,
      ALERT_ACTIONS.changeState
    ]
    const alertNode = raw?.alert?.edges?.[0]?.node
    const subAlerts = alertNode?.subAlerts?.edges || []
    const objectCount = alertNode?.objectCount || 0

    const list = subAlerts.map(({ node: subAlert }) => {
      const object = subAlert?.objects?.edges?.[0]?.node

      const groupsList =
        object?.groupAccess?.edges?.map(({ node }) => ({
          id: node?.id,
          name: node?.name
        })) || []

      const usersList =
        object?.userAccess?.edges?.map(({ node }) => ({
          id: node?.id,
          name: node?.name
        })) || []

      const writeAccess =
        object?.writeAccess?.edges?.map(({ node }) => ({
          id: node?.id,
          name: node?.name
        })) || []

      const readAccess =
        object?.readAccess?.edges?.map(({ node }) => ({
          id: node?.id,
          name: node?.name
        })) || []

      const fileShareData = object?.fileShare?.edges?.[0]?.node || {}
      const project = object?.project?.edges?.[0]?.node
      const bucket = object?.bucket?.edges?.[0]?.node
      const approvalCycles = (subAlert?.approvalDetails || []).map((detail) => {
        return {
          ...detail,
          approvalRequestAlertHistory:
            detail?.approvalRequestAlertHistory?.edges?.map(({ node }) => node) || [],
          approvalResponseAlertHistory:
            detail?.approvalResponseAlertHistory?.edges?.map(({ node }) => node) || []
        }
      })
      // Each approvalDetails item is one approval cycle for one action.
      // The Objects Impacted tooltip should only show cycles that are pending for approval/rejection.
      // Rejected cycles only drive the red warning tooltip if no requested cycle exists.
      const requestedApprovalCycles = approvalCycles.filter(
        (cycle) => cycle?.approvalStatus === SubAlertActionApprovalStates.requested
      )
      const rejectedApprovalCycles = approvalCycles.filter(
        (cycle) => cycle?.approvalStatus === SubAlertActionApprovalStates.rejected
      )
      const approvalRequestAlertHistory = requestedApprovalCycles.reduce((acc, cycle) => {
        const history = (cycle?.approvalRequestAlertHistory || []).filter((item) =>
          tooltipActions.includes(item?.action)
        )
        return [...acc, ...history]
      }, [])
      const approvalResponseAlertHistory = rejectedApprovalCycles.reduce((acc, cycle) => {
        const history = (cycle?.approvalResponseAlertHistory || []).filter((item) =>
          tooltipActions.includes(item?.action)
        )
        return [...acc, ...history]
      }, [])

      const result: IAlertObjectsImpacted = {
        id: subAlert?.id,
        assignee: subAlert?.assignee || '',
        generatedAt: subAlert?.generatedAt || '',
        lastAccessTime: subAlert?.lastAccessTime || '',
        documentId: object?.id || '',
        documentName: object?.name || '',
        attributesCount: object?.attribute?.count || 0,
        groupsList,
        usersList,
        readAccessList: readAccess,
        writeAccessList: writeAccess,
        createdBy: object?.owner || '',
        lastModified: object?.lastModifiedTime || null,
        owner: object?.owner || '',
        folder: object?.folder || {},
        riskScore: object?.riskScore || null,
        shareData: {
          shareId: fileShareData?.id,
          shareName: fileShareData?.name
        },
        projectName: project?.name || '',
        projectId: project?.id || '',
        bucketName: bucket?.displayName || bucket?.name || '',
        bucketOwner: bucket?.ownerName || '',
        // access control
        users: object?.userAccess?.edges?.map(({ node }) => node) || [],
        groups: object?.groupAccess?.edges?.map(({ node }) => node) || [],
        template:
          object?.template?.edges && object.template.edges.length > 0
            ? object.template.edges[0].node
            : undefined,
        userAccessCount: object?.userAccess?.count || 0,
        groupAccessCount: object?.groupAccess?.count || 0,
        actionState: subAlert?.state,
        // approval details
        approvalStatus: requestedApprovalCycles.length
          ? SubAlertActionApprovalStates.requested
          : rejectedApprovalCycles.length
          ? SubAlertActionApprovalStates.rejected
          : undefined,
        approvalRequestAlertHistoryId:
          requestedApprovalCycles[0]?.approvalRequestAlertHistoryId ||
          rejectedApprovalCycles[0]?.approvalRequestAlertHistoryId ||
          '',
        approvalRequestAlertHistory,
        approvalResponseAlertHistory
      }

      return result
    })

    return { list, objectCount }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const queryExtendedGenericObjectsImpacted = (
  params: FetchExtendedObjectsImpactedParams
): string => {
  const { alertId, objectId, datasourceId, subAlertId, dataSourceType } = params

  const isGdrive = dataSourceType === DATA_SOURCE_TYPES?.gdrive
  const isOneDrive = dataSourceType === DATA_SOURCE_TYPES?.oneDrive
  const isSharePoint = dataSourceType === DATA_SOURCE_TYPES?.sharePoint

  return gql`
    {
      objects(
        first: 1,
        id: "${objectId}"
        ${datasourceId ? `datasourceIds: ["${datasourceId}"]` : ''}
        filter: [
          { key: ${GRAPHQL_API_FILTERS.alertIds}, values: ["${alertId}"] }
        ]
      ) {
        edges {
          node {
            classification
            labels {
              edges {
                node {
                  id
                  name
                }
              }
            }
            createdAt
            objectLink
            attribute {
              edges {
                node {
                  name
                  internalName
                }
              }
            }
            entity {
              count
              edges {
                node {
                  id
                  name
                }
              }
            }
            subAlert(
              first: 1,
              id: "${subAlertId}"
            ) {
              edges {
                node {
                  id
                }
              }
            }
            sharedWith {
              email
              name
              role
              isInternal
            }
            ${
              isGdrive || isOneDrive || isSharePoint
                ? `
              drive {
                edges {
                  node {
                    driveId
                    driveName
                    owner
                    ${isSharePoint ? 'site { edges { node { name siteId } } }' : ''}
                  }
                }
              }`
                : ''
            }
          }
        }
      }
    }
  `
}

export const mapExtendedGenericObjectsImpacted = (
  raw: any,
  alertId: string
): ExtendedAlertObjectsImpacted => {
  const object = raw?.objects?.edges[0]?.node

  const attributesList =
    object?.attribute?.edges?.map(({ node: attr }) => ({
      name: attr?.name,
      internalName: attr?.internalName
    })) || []

  const entitiesList =
    object?.entity?.edges
      ?.filter(({ node }) => !!node?.name)
      ?.map(({ node }) => ({
        id: node?.id,
        name: Array?.isArray(node?.name) ? node?.name[0] : node?.name
      })) || []

  const driveData = object?.drive?.edges[0]?.node

  return {
    alertId,
    subAlertId: object?.subAlert?.edges[0]?.node?.id,
    labels: object?.labels?.edges?.map(({ node }) => node),
    attributesList,
    entitiesList,
    classification: object?.classification,
    createdAt: object?.createdAt,
    objectLink: object?.objectLink,
    driveData: driveData && {
      driveId: driveData.driveId,
      driveName: driveData.driveName,
      driveOwner: driveData.owner
    },
    siteData: driveData && {
      siteId: driveData.site?.edges[0]?.node?.siteId,
      siteOwner: driveData.owner,
      siteName: driveData.site?.edges[0]?.node?.name || ''
    },
    sharedWith: object?.sharedWith
  }
}

export const queryAlertEmailsImpacted = (params: EmailsImpactedParams): string => {
  const { page, filters, datasourceId, pageSize = LIMIT_DEFAULT, alertId } = params
  const cursor = getAfterCursor(page, pageSize)

  const combinedFilters = [...(filters?.filter ?? []), ...(filters?.subAlertFilter ?? [])]

  return gql`
    {
      alert(
        datasourceIds: ["${datasourceId}"]
        id: "${alertId}"
        first: 1
      ) {
        edges {
          node {
            objectCount
            subAlerts(
              first: ${pageSize}
              after: "${cursor}"
              ${
                combinedFilters.length
                  ? `filter: ${parameterizeArrayofObjects(combinedFilters)}`
                  : ''
              }
            ) {
              edges {
                node {
                  id
                  assignee
                  generatedAt
                  state
                  objects(first: 1) {
                    edges {
                      node {
                        id
                        type
                        name
                        category
                        attributes
                        tableClusterName
                        classification
                        labels {
                          edges {
                            node {
                              id
                              name
                            }
                          }
                        }
                        owner
                        lastModifiedTime
                        createdAt
                        objectLink
                        riskScore
                        folder {
                          id
                          path
                          name
                          webUrl
                        }
                        entity {
                          count
                          edges {
                            node {
                              id
                              name
                            }
                          }
                        }
                        attribute {
                          count
                          edges {
                            node {
                              name
                              internalName
                            }
                          }
                        }
                        mail {
                          edges {
                            node {
                              id
                              type
                              refMailboxIds
                              messageId
                              timestamp
                              subject
                              sender {
                                email
                              }
                              recipients {
                                email
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapQueryAlertEmailsImpacted = (
  raw: any
): { list: IAlertObjectsImpacted[]; mailCount: number } => {
  try {
    const alertNode = raw?.alert?.edges?.[0]?.node
    const subAlerts = alertNode?.subAlerts?.edges || []
    const mailCount = alertNode?.objectCount || 0

    const list: IAlertObjectsImpacted[] = subAlerts.map(({ node: subAlert }) => {
      const object = subAlert?.objects?.edges?.[0]?.node
      const mail = object?.mail?.edges?.[0]?.node

      const result: IAlertObjectsImpacted = {
        id: subAlert?.id,
        assignee: subAlert?.assignee || '',
        generatedAt: subAlert?.generatedAt || '',
        documentId: object?.id || '',
        documentName: object?.name || '',
        createdBy: object?.owner || '',
        lastModified: object?.lastModifiedTime || null,
        owner: object?.owner || '',
        riskScore: object?.riskScore || null,

        attachments:
          object?.category === OBJECT_TYPES.file
            ? [{ id: object.id, type: object.type, name: object.name }]
            : [],

        actionState: subAlert?.state,
        attributesCount: object?.attribute?.count || 0,
        entitiesCount: object?.entity?.count || 0,

        mailSubject: mail?.subject || object?.name || '',
        mailFrom: mail?.sender?.email || '',
        mailTo: mail?.recipients?.map(({ email }) => email) || [],
        type: mail?.type || '',
        refMailboxIds: mail?.refMailboxIds || [],
        messageId: mail?.messageId,
        sharedOn: mail?.timestamp || object?.createdAt || '',

        folder: object?.folder
      }

      return result
    })

    return { list, mailCount }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const queryExtendedAlertEmailsImpacted = (params: FetchExtendedObjectsImpactedParams) => {
  const { datasourceId, alertId, subAlertId } = params

  return gql`
    {
      alert(
        first: 1
        id: "${alertId}"
        ${datasourceId ? `datasourceIds: ["${datasourceId}"]` : ''}
      ) {
        edges {
          node {
            subAlerts(
              first: 1
              filter: [{key: STATUS, values: "Active"}]
              id: "${subAlertId}"
            ) {
              edges {
                node {
                  id
                  objects(first: 1) {
                    edges {
                      node {
                        createdAt
                        classification
                        attribute {
                          edges {
                            node {
                              name
                              internalName
                            }
                          }
                        }
                        entity {
                          count
                          edges {
                            node {
                              id
                              name
                            }
                          }
                        }
                        labels {
                          edges {
                            node {
                              id
                              name
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapExtendedAlertEmailsImpacted = (
  raw: any,
  alertId: string
): ExtendedAlertObjectsImpacted => {
  const subAlertEdges2 = raw?.alert?.edges[0]?.node?.subAlerts?.edges ?? []
  const subAlert = subAlertEdges2.length > 0 ? subAlertEdges2[0].node : undefined

  const attributesList =
    subAlert?.objects?.edges[0]?.node?.attribute?.edges?.map(({ node: attr }) => ({
      name: attr?.name,
      internalName: attr?.internalName
    })) || []
  const entitiesList =
    subAlert?.objects?.edges[0]?.node?.entity?.edges
      ?.filter(({ node }) => !!node?.name)
      ?.map(({ node }) => ({
        id: node?.id,
        name: Array?.isArray(node?.name) ? node?.name[0] : node?.name
      })) || []
  const labels = subAlert?.objects?.edges[0]?.node?.labels?.edges?.map(({ node }) => node) || []

  return {
    subAlertId: subAlert?.id,
    alertId,
    attributesList,
    entitiesList,
    labels,
    createdAt: subAlert?.objects?.edges[0]?.node?.createdAt,
    classification: subAlert?.objects?.edges[0]?.node?.classification
  }
}

export const queryAlertObjectsGroups = (params: AlertObjectsGroupParams): string => {
  const { alertId, user } = params

  const userFilter = user ? `user: "${user}"` : ''
  return gql`
    {
      alertGroupByUser(alertId: "${alertId}" ${userFilter}) {
        edges {
          node {
            user {
              email
            }
            alertMeta {
              id
              numActiveSubalerts
            }
          }
        }
      }
    }
  `
}
export const mapQueryAlertObjectsGroups = (raw: any): AlertObjectsGroup[] => {
  try {
    return raw?.alertGroupByUser?.edges?.map(({ node: group }) => ({
      owner: group?.user?.email,
      objectsCount: group?.alertMeta[0]?.numActiveSubalerts || 0
    }))
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const queryRulesetAttributes = (id?: string): string => {
  const idFragment = id ? `id: "${id}"` : ''

  return gql`
    {
      attributeSet(first: 999, ${idFragment}) {
        edges {
          node {
            id
            name
            type
            enabled
            systemDefined
            attributes {
              count
              edges {
                node {
                  id
                  name
                  sensitivityLabel
                }
              }
            }
          }
        }
      }
    }
  `
}
export const mapQueryRulesetAttributes = (
  raw: any
): { attributeSets: AttributeSet[]; attributesBySensitivity: AttributesBySensitivity } => {
  try {
    const attributesBySensitivity: AttributesBySensitivity = {}
    const attributeSets = raw?.attributeSet?.edges?.map(({ node: attrSet }) => {
      const attributes =
        attrSet?.attributes?.edges?.map(({ node: attr }) => {
          const attribute = {
            id: attr?.id,
            name: attr?.name,
            setId: attrSet?.id,
            sensitivityLabel: attr?.sensitivityLabel
          }

          return attribute
        }) || []

      return {
        id: attrSet?.id,
        name: attrSet?.name,
        enabled: attrSet?.enabled,
        description: attrSet?.description || '',
        type: attrSet?.type || '',
        attributesCount: attrSet?.attributes?.count || 0,
        attributes: sortAttributesByInstanceCountAndSensitivity(attributes, SORT_ORDER?.DESC)
      }
    })
    const sortedAttributeSets = sortByOrder<AttributeSet>(
      attributeSets,
      'instanceCount',
      SORT_ORDER?.DESC
    )?.sort((a, b) => +b?.enabled - +a?.enabled)

    const activeAttributeSets = attributeSets?.filter((set) => set?.enabled)
    const allAttributes = removeDuplicates<AttributeSetAttribute>(
      activeAttributeSets?.reduce((acc, set) => acc?.concat(set?.attributes), []),
      'id'
    )

    attributesBySensitivity[SENSITIVE_LABEL?.HIGH] = allAttributes?.filter(
      (attr) => attr?.sensitivityLabel === SENSITIVE_LABEL?.HIGH
    )
    attributesBySensitivity[SENSITIVE_LABEL?.MEDIUM] = allAttributes?.filter(
      (attr) => attr?.sensitivityLabel === SENSITIVE_LABEL?.MEDIUM
    )
    attributesBySensitivity[SENSITIVE_LABEL?.LOW] = allAttributes?.filter(
      (attr) => attr?.sensitivityLabel === SENSITIVE_LABEL?.LOW
    )

    return {
      attributeSets: sortedAttributeSets,
      attributesBySensitivity
    }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const mutationSaveArchivalLocation = (params: SaveArchivalLocationParams) => {
  return gql`
    mutation policyActionConfiguration {
      updatePolicyActionConfiguration(
        clientMutationId: "1"
        datasourceId: "${params?.id}"
        input: {
          polciyActionConfiguration: [
            {
              actionType: ARCHIVE_OBJECT
              configuration: { archiveConfiguration: {
                  archiveLocation: "${params?.archiveLocation}"
                  ${
                    params.driveId
                      ? `archiveMetadata: {
                        archiveMode: CROSS_SITE
                        targetSiteId: "${params.siteId}"
                        targetSiteName: "${params.siteName}"
                        targetDriveId: "${params.driveId}"
                        targetDriveName: "${params.driveName}"
                      }`
                      : ''
                  }
                }
              }
            }
          ]
        }
      ) {
        clientMutationId
      }
    }
  `
}

export const queryAlertActionHistory = ({
  alertId,
  generatedAtStart,
  generatedAtEnd,
  page
}: ActionHistoryParams) => {
  const cursor = getAfterCursor(page ?? 1, LIMIT_DEFAULT)
  const afterClause = cursor ? `, after: "${cursor}"` : ''
  const query = gql`
  {
    subAlert(id: "${alertId}", first: 1) {
      count
      edges {
        node {
          id
          assignee
          objects(first: 1) {
            edges {
              node {
                id
                name
              }
            }
          }
          triggeredTime
          generatedAt
          subAlertHistory(first: ${LIMIT_DEFAULT}${afterClause}, dateFilter: {key: ${SubAlertDateFilterKey?.TriggeredTime}, start: ${generatedAtStart}, end: ${generatedAtEnd}}) {
            count
            edges {
              cursor
              node {
                alertHistory {
                  edges {
                    cursor
                    node {
                      id
                      triggeredBy
                      triggeredTimestamp
                      action
                      approvalDetails {
                        approvalStatus
                        approvalAction
                      }
                      actionMetadata {
                        ... on ChangeStateActionOutput{
                            newState
                          }
                      }
                      comment
                      config {
                        __typename
                        ... on ReassignConfig {
                          newAssignee
                          subAlertAssignmentStrategy {
                            globalStrategy
                          }
                        }
                        ... on MuteConfig {
                          muteTillTimestamp
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`

  return query
}
export const mapQueryAlertActionHistory = (data: any): ObjectAlertActionHistory => {
  const subAlertHistory = data?.subAlert?.edges[0]?.node?.subAlertHistory
  const edges = subAlertHistory?.edges || []
  const result = {
    object: data?.subAlert?.edges[0]?.node?.objects?.edges[0]?.node,
    alertHistory: edges
      .map((edge) => edge?.node?.alertHistory?.edges[0]?.node)
      .filter((log) => !!log),
    totalCount: subAlertHistory?.count || 0,
    endCursor: edges.length > 0 ? edges[edges.length - 1]?.cursor : undefined
  }
  return result
}

export const queryInformationExtractionParams = () => {
  return gql`
    query IEM {
      attribute(isInformationExtraction: true, filter: { key: DATA_TYPE, values: ["DATE"] }) {
        edges {
          node {
            id
            name
            internalName
            enabled
          }
        }
      }
    }
  `
}

export const mapQueryInformationExtractionParams = (data: any): InformationExtractionParams[] => {
  if (!data?.attribute) return []

  const params = data?.attribute?.edges?.map((edge) => {
    return {
      id: edge?.node?.id,
      name: edge?.node?.name,
      enabled: edge?.node?.enabled
    }
  })

  return params
}

export const mutationCreateRansomewareActivityFilter = ({
  accessCount,
  accessInterval,
  accessedByIdentityType
}: ICreateRansomewareActivityFilterParams): any => {
  return gql`
    mutation {
      createFilter(
        clientMutationId: ""
        filterData: {
          name: "Ransomware Activity-${Math.random()}"
          owner: "Admin"
          description: "This is test filter."
          type: EXCESSIVE_WRITES_FILTERS
          configuration: {
            excessiveWritesFilters: {
              accessCount: ${accessCount}
              accessInterval: {
                value: ${accessInterval.value},
                valueType: ${accessInterval.valueType}
              },
              accessedByIdentityType: ${accessedByIdentityType}
            }
          }
        }
      ) {
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const mutationUpdateRansomewareActivityFilter = ({
  accessCount,
  accessInterval,
  accessedByIdentityType
}: ICreateRansomewareActivityFilterParams): any => {
  return gql`
    mutation {
      updateFilter(
        clientMutationId: ""
        filterData: {
          name: "Ransomware Activity-${Math.random()}"
          owner: "Admin"
          description: "This is test filter."
          type: EXCESSIVE_WRITES_FILTERS
          configuration: {
            excessiveWritesFilters: {
              accessCount: ${accessCount}
              accessInterval: {
                value: ${accessInterval.value},
                valueType: ${accessInterval.valueType}
              },
              accessedByIdentityType: ${accessedByIdentityType}
            }
          }
        }
      ) {
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const queryUpdateRansomewareActivityFilter = ({
  id,
  accessCount,
  accessInterval,
  accessedByIdentityType
}: IUpdateRansomewareActivityFilterParams) => {
  return gql`
    mutation{
      updateFilter(
        clientMutationId: "updateRansomewareActivityFilter",
        id: "${id}"
        filterData: {
          type: EXCESSIVE_WRITES_FILTERS
          configuration: {
            excessiveWritesFilters: {
              accessCount: ${accessCount}
              accessInterval: {
                value: ${accessInterval.value},
                valueType: ${accessInterval.valueType}
              },
              accessedByIdentityType: ${accessedByIdentityType}
            }
          }
        }
      ){
        clientMutationId
        filter {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  `
}

export const queryAlertIncidents = (params: QueryAlertIncidentsParams) => {
  const { alertId, page = 1, pageSize = LIMIT_DEFAULT, userIds, state, keyword } = params

  const cursor = getAfterCursor(page, pageSize)

  return gql`
    query subAlert1 {
      alert(
        first: 1,
        id: "${alertId}"
      ) {
        edges {
          node {
            subAlerts(
              ${keyword.length ? `search: "${keyword}"` : ''}
              first: ${pageSize}
              after: "${cursor}"
              filter: [
                ${
                  userIds?.length
                    ? `{ key: ${GRAPHQL_API_FILTERS.userIds}, values: [${userIds
                        .map((userId) => `"${userId}"`)
                        .join(',')}] }`
                    : ''
                }
                ${
                  state?.length
                    ? `{ key: ${GRAPHQL_API_FILTERS.state}, values: [${state
                        .map((state) => `"${state}"`)
                        .join(',')}] }`
                    : ''
                }
              ]
            ) {
              count
              edges {
                node {
                  id
                  datasource {
                    edges {
                      node {
                        id
                        type
                      }
                    }
                  }
                  name
                  state
                  groupId
                  interval
                  eventType
                  excessiveWriteFileCount
                  anomalyTime
                  totalActivityCount
                  accessActivityTime
                  fileAccessCount
                  users {
                    edges {
                      node {
                        id
                        name
                        employeeType
                        departmentName
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export type AlertIncidentUser = {
  id: string
  name: string
}

export enum IncidentThresholdExceeded {
  DAILY = 'Daily',
  HOURLY = 'Hourly',
  MONTHLY = 'Monthly'
}
export type AlertIncidentEvent = {
  eventType: 'Read' | 'Write' | 'Download' | 'Delete'
  count: number
}

export enum AlertIncidentEventType {
  READ = 'READ',
  DELETE = 'DELETE',
  DOWNLOAD = 'DOWNLOAD',
  WRITE = 'WRITE'
}

export const alertIncidentEventTypeToColor = {
  [AlertIncidentEventType.READ]: 'information',
  [AlertIncidentEventType.DOWNLOAD]: 'thistle',
  [AlertIncidentEventType.DELETE]: 'error'
} as const

export enum AlertIncidentSchedule {
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY'
}

export type AlertIncident = {
  id: string
  name: string
  state: SubAlertActionState
  groupId?: string
  excessiveWriteFileCount?: number
  eventType?: AlertIncidentEventType
  fileAccessCount?: number
  interval?: AlertIncidentSchedule
  totalActivityCount?: number
  anomalyTime?: string
  accessActivityTime?: string
  // ! FIXME: this is a hotfix for Farhan's endDate
  endDate?: string
  datasourceId: string
  datasourceType: DATA_SOURCE_TYPES
  users: AlertIncidentUser[]
  thresholdExceeded?: IncidentThresholdExceeded
  uniqueObjectsCount?: number
  eventTypes?: AlertIncidentEvent[]
}
export type QueryAlertIncidentsResult = {
  objectCount: number
  userCount: number
  incidents: {
    count: number
    list: AlertIncident[]
  }
}
export const mapAlertIncidents = (raw) => {
  const alertIncidents = raw.alert.edges?.[0].node.subAlerts.edges.map(({ node }) => {
    const alertIncident: AlertIncident = {
      id: node.id,
      name: node.name,
      groupId: node.groupId,
      state: node.state,
      accessActivityTime: node.accessActivityTime as string,
      datasourceId: node.datasource.edges[0].node.id,
      datasourceType: node.datasource.edges[0].node.type,
      excessiveWriteFileCount: node.excessiveWriteFileCount,
      anomalyTime: node.anomalyTime,
      totalActivityCount: node.totalActivityCount,
      eventType: node.eventType,
      fileAccessCount: node.fileAccessCount,
      interval: node.interval,
      users: node.users.edges?.map(({ node }) => ({
        id: node.id,
        name: node.name,
        employeeType: node.employeeType,
        departmentName: node.departmentName
      }))
    }

    return alertIncident
  })

  return {
    count: raw.alert.edges?.[0].node.subAlerts.count,
    list: alertIncidents
  }
}

export const queryAlertIncidentsSummary = (params: Pick<QueryAlertIncidentsParams, 'alertId'>) => {
  const { alertId } = params

  return gql`
    query subAlert {
      alert(
        first: 1,
        id: "${alertId}"
      ) {
        edges {
          node {
            objectCount
            userCount
          }
        }
      }
    }
  `
}
export const mapAlertIncidentsSummary = (raw) => {
  return {
    objectCount: raw.alert.edges?.[0].node.objectCount,
    userCount: raw.alert.edges?.[0].node.userCount
  }
}
export type IncidentImpactedObject = {
  id?: string
  name: string
  eventTime: string
  dataSource?: {
    id: string
    type: DATA_SOURCE_TYPES
  }
}

const buildDateFilter = (startDate?: string, endDate?: string) => {
  if (startDate === undefined && endDate === undefined) return ''
  const start = startDate !== undefined ? ` start: "${startDate}"` : ''
  const end = endDate !== undefined ? ` end: "${endDate}"` : ''
  return `dateFilter: {${start}${end} }`
}

export const queryIncidentImpactedObjects = (args: FetchImpactedObjectsParams) => {
  const { datasourceId, userId, page, pageSize, filters, startDate, endDate } = args

  const after = getAfterCursor(page, pageSize)

  return gql`
    query impactedObjects {
      fileAccessEvent(
        first: ${pageSize}
        after: "${after}"
        userId: ${userId}
        datasourceId: "${datasourceId}"
        ${filters?.filter ? `filter: ${parameterizeArrayofObjects(filters?.filter)}` : ''}
        ${buildDateFilter(startDate, endDate)}
      ) {
        edges {
          node {
            objectName
            eventTime
            object {
              id
              datasource {
                edges {
                  node {
                    id
                    type
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapIncidentImpactedObjects = (raw) => {
  return raw.fileAccessEvent.edges.map(({ node }) => {
    const impactedObject: IncidentImpactedObject = {
      id: node.object?.id,
      name: node.objectName,
      eventTime: node.eventTime,
      dataSource: node.object?.datasource
        ? {
            id: node.object.datasource.edges[0].node.id,
            type: mapDataSourceApiTypesToStandard(node.object.datasource.edges[0].node.type)
          }
        : undefined
    }

    return impactedObject
  })
}

export const queryIncidentImpactedObjectsCount = (args: FetchImpactedObjectsParams) => {
  const { datasourceId, userId, page, pageSize, filters, startDate, endDate } = args

  const after = getAfterCursor(page, pageSize)

  return gql`
    query impactedObjects {
      fileAccessEvent(
        first: ${pageSize}
        after: "${after}"
        userId: ${userId}
        datasourceId: "${datasourceId}"
        ${filters?.filter ? `filter: ${parameterizeArrayofObjects(filters?.filter)}` : ''}
        ${buildDateFilter(startDate, endDate)}
      ) {
        count
      }
    }
  `
}

export const queryIncidentRecentAccessRecords = (args: FetchIncidentRecentAccessRecordsParams) => {
  const { page, pageSize, userId, datasourceId, startDate, endDate } = args

  const after = getAfterCursor(page, pageSize)

  return gql`
    query recentAccess {
      fileAccessEvent(
        first: ${pageSize}
        userId: ${userId}
        after: "${after}"
        datasourceId: "${datasourceId}"
        dateFilter: {
          start: "${startDate}"
          end: "${endDate}"
        }
        booleanFilter: [{ key: IS_DISTINCT_FILES, value: false }]
      ) {
        edges {
          node {
            objectName
            objectUrl
            rawObjectUrl
            eventTime
            objectType
            reportRowCount
            object {
              id
              name
              lastModifiedTime
              attribute {
                count
              }
              folder {
                id
              }
            }
            accessControlObject {
              id
            }
            accessType
          }
        }
      }
    }
  `
}

export const mapIncidentRecentAccessRecords = (raw): IncidentRecentAccessRecord[] => {
  return raw.fileAccessEvent.edges.map(({ node }) => {
    const record: IncidentRecentAccessRecord = {
      id: node.object?.id,
      accessControlObjectId: node.accessControlObject?.id,
      objectName: node.object?.name ?? node.objectName,
      objectUrl: node.rawObjectUrl ?? node.objectUrl,
      attributesCount: node.object?.attribute?.count,
      folderId: node.object?.folder?.id ?? 0,
      accessType: node.accessType as IncidentAccessType,
      lastModifiedTime: node.object?.lastModifiedTime,
      eventTime: node.eventTime,
      objectType: node.objectType,
      reportRowCount: node.reportRowCount
    }

    return record
  })
}

export const queryIncidentRecentAccessRecordsCount = (
  args: FetchIncidentRecentAccessRecordsParams
) => {
  const { page, pageSize, userId, datasourceId, startDate, endDate } = args

  const after = getAfterCursor(page, pageSize)

  return gql`
    query recentAccess {
      fileAccessEvent(
        first: ${pageSize}
        userId: ${userId}
        after: "${after}"
        datasourceId: "${datasourceId}"
        dateFilter: {
          start: "${startDate}"
          end: "${endDate}"
        }
        booleanFilter: [{ key: IS_DISTINCT_FILES, value: false }]
      ) {
        count
      }
    }
  `
}

export const queryIncidentRecentAccessObject = (params: FetchIncidentRecentAccessObjectParams) => {
  const { objectId } = params

  return gql`
    query recentAccessObject {
      objects (
        first: 1
        id: "${objectId}"
      ) {
        edges {
          node {
            id
            classification
            owner
            createdAt
            attribute {
              edges {
                node {
                  name
                  internalName
                }
              }
            }
            entity {
              edges {
                node {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapIncidentRecentAccessObject = (raw): IncidentRecentAccessObject => {
  const objectNode = raw.objects.edges?.[0]?.node

  const record: IncidentRecentAccessObject = {
    id: objectNode?.id,
    classification: objectNode?.classification,
    owner: objectNode?.owner,
    createdAt: objectNode?.createdAt,
    attributes:
      objectNode?.attribute?.edges?.map(({ node: attr }) => ({
        name: attr?.name,
        internalName: attr?.internalName
      })) || [],
    entities:
      objectNode?.entity?.edges
        ?.filter(({ node }) => !!node?.name)
        ?.map(({ node }) => ({
          id: node?.id,
          name: Array?.isArray(node?.name) ? node?.name[0] : node?.name
        })) || []
  }

  return record
}

export const queryAlertIncidentsUsersFilter = (args: FetchAlertIncidentsUsersFilterParams) => {
  const { page, pageSize, keyword, alertId } = args

  const cursor = getAfterCursor(page, pageSize)

  return gql`
    {
      accessControlUsers(
        first: ${pageSize}
        ${cursor ? `after: "${cursor}"` : ''}
        ${keyword ? `search: "${keyword}"` : ''}
        ${alertId ? `alertId: "${alertId}"` : ''}
      ) {
        count
        edges {
          node {
            id
            name
          }
        }
      }
    }
  `
}

export const mapAlertIncidentsUsersFilter = (raw) => {
  return {
    count: raw.accessControlUsers.count,
    list: raw.accessControlUsers.edges.map(({ node }) => ({
      id: node.id,
      name: node.name
    }))
  }
}

export const queryAlertUsers = (params: QueryAlertUsersParams) => {
  const { alertId, userType = AlertUserType.objectOwner } = params

  return gql`
    query {
      alertGroupByUser(alertId: "${alertId}", userType: ${userType}) {
        count
        edges {
          node {
            user {
              id
              name
            }
            alertMeta {
              id
              numActiveSubalerts
            }
          }
        }
      }
    }
  `
}
export type AlertUser = {
  id: string
  name?: string
  numActiveSubalerts?: number
}
export const mapAlertUsers = (
  raw
): {
  count: number
  list: AlertUser[]
} => {
  const edges = raw.alertGroupByUser?.edges || []

  const users = edges.map(({ node }) => {
    const { user, alertMeta } = node
    return {
      id: user?.id || '',
      name: user?.name || '',
      numActiveSubalerts: alertMeta?.[0]?.numActiveSubalerts ?? 0
    }
  })

  return {
    count: raw.alertGroupByUser?.count || 0,
    list: users
  }
}

export const mutationSuspendUser = (params: MutationSuspendUserParams) => {
  return gql`
    mutation suspend_user {
      disableAccountSubAlert(
        actionInput: {
          clientMutationId: "1",
          alertId: "${params?.alertId}",
          subAlertIds: ${JSON.stringify(params?.subAlertIds)},
          triggeredBy: "${params?.triggeredBy}",
        }
      ) {
        status
        clientMutationId
      }
    }
  `
}

export const querySubAlertOwnerFilter = (params: SubAlertOwnerFilterParams) => {
  const { alertId, userType = AlertUserType.objectOwner, searchFilter } = params

  let searchFilterArg = ''
  if (searchFilter && searchFilter.length > 0) {
    const filters = searchFilter
      .map(({ key, value }) => `{key: ${key}, value: "${value}"}`)
      .join(',')
    searchFilterArg = `, searchFilter: [${filters}]`
  }

  return gql`
    query {
      alertGroupByUser(alertId: "${alertId}", userType: ${userType} ${searchFilterArg}) {
        count
        edges {
          node {
            user {
              email
            }
          }
        }
      }
    }
  `
}

export const mapSubAlertOwnerFilter = (raw): { list: string[]; count: number } => {
  try {
    const edges = raw.alertGroupByUser?.edges || []
    const emails = edges
      .map(({ node }) => {
        return node?.user?.email || ''
      })
      .filter((email) => email !== '')

    return { list: emails, count: raw.alertGroupByUser?.count || 0 }
  } catch (error) {
    console.error('Error mapping sub-alert owner filter:', error)
    return { list: [], count: 0 }
  }
}

export const queryAccessControlUsers = (idpId: string) => {
  return gql`
    query {
      accessControlUsers(
        idpId: "${idpId}"
      ) {
        count
        edges {
          node {
            id
            name
            email
          }
        }
      }
    }
  `
}

export const mapAccessControlUsers = (raw: any) => {
  try {
    const edges = raw?.accessControlUsers?.edges || []
    const users = edges.map(({ node }) => ({
      id: node?.id || '',
      name: node?.name || '',
      email: node?.email || ''
    }))
    return { users, count: raw?.accessControlUsers?.count || 0 }
  } catch (error) {
    console.error('Error mapping access control users:', error)
    return { users: [], count: 0 }
  }
}

export const queryAlertImpactedUsers = (params: AlertImpactedUsersParams) => {
  const {
    alertId,
    departmentName,
    employeeType,
    accountStatus,
    lastActiveOn,
    filterActionState,
    page = 1
  } = params

  let lastActiveOnFilter = ''
  if (lastActiveOn) {
    const lastActiveOnRange = getCustomDateRange(lastActiveOn)
    lastActiveOnFilter += `dateFilter: { key: LAST_ACTIVE_ON, start: ${lastActiveOnRange?.start}, end: ${lastActiveOnRange?.end}}`
  }

  const cursor = getAfterCursor(page, LIMIT_DEFAULT)

  return gql`
    query users {
      alert(first: 1, id: "${alertId}") {
        edges {
          node {
            subAlerts(
              first: ${LIMIT_DEFAULT}
              after: "${cursor}"
              filter: [
                ${
                  filterActionState
                    ? `{ key: STATE, values: ${JSON.stringify(
                        filterActionState
                          .split(',')
                          .map((state) => ExtendedSubAlertActionStateFilter[state])
                      )} }`
                    : ''
                }
                ${departmentName ? `{ key: DEPARTMENT, values: ["${departmentName}"] }` : ''}
                ${employeeType ? `{ key: EMPLOYEE_TYPE, values: ["${employeeType}"] }` : ''}
                ${accountStatus ? `{ key: ACCOUNT_STATUS, values: ["${accountStatus}"] }` : ''}
              ]
              ${lastActiveOnFilter}
            ) {
              count
              edges {
                node {
                  id
                  state
                  assignee
                  ownedObjects {
                    totalObjectCount
                    totalDatasourceCount
                  }
                  users {
                    edges {
                      node {
                        id
                        name
                        employeeType
                        departmentName
                        accountStatus
                        lastLoggedInAt
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapQueryAlertImpactedUsers = (raw) => {
  try {
    const subAlertsEdges = raw?.alert?.edges?.[0]?.node?.subAlerts?.edges || []
    const list = subAlertsEdges
      .map(({ node }) => {
        const subAlertUser = node?.users?.edges?.[0]?.node
        const ownedObjects = node?.ownedObjects
        if (!subAlertUser) {
          return null
        }
        return {
          id: node.id,
          userId: subAlertUser.id,
          name: subAlertUser.name,
          state: node.state,
          assignee: node.assignee,
          employeeType: subAlertUser.employeeType,
          departmentName: subAlertUser.departmentName,
          accountStatus: subAlertUser.accountStatus,
          lastLoggedInAt: subAlertUser.lastLoggedInAt,
          objectsCount: ownedObjects?.totalObjectCount || 0,
          datasourcesCount: ownedObjects?.totalDatasourceCount || 0
        }
      })
      .filter(Boolean) // Filter out any null entries

    const count = raw?.alert?.edges?.[0]?.node?.subAlerts?.count || 0

    return { list, count }
  } catch (error) {
    console.error('Error mapping alert impacted users:', error)
    return { list: [], count: 0 }
  }
}

export const queryObjectsOwnedBySubAlert = (params: ObjectsOwnedBySubAlertParams) => {
  const { alertId, subAlertId } = params

  return gql`
    query objectOwnedMapBySubAlert {
      alert(first: 1, id: "${alertId}") {
        edges {
          node {
            subAlerts(
              first: 1,
              id: "${subAlertId}"
            ) {
              count
              edges {
                node {
                  id
                  ownedObjects {
                    datasourceToObjectCountList {
                      datasourceId
                      datasourceType
                      datasourceName
                      objectCount
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapQueryObjectsOwnedBySubAlert = (raw) => {
  try {
    const list = raw?.alert?.edges?.[0]?.node?.subAlerts?.edges[0]?.node.ownedObjects?.datasourceToObjectCountList.map(
      (listItem) => listItem
    )
    return list
  } catch (error) {
    console.error('Error mapping objects owned by sub alert:', error)
    return []
  }
}

export const queryAlertPendingRequests = (params: { alertId: string }) => {
  const { alertId } = params
  return gql`
  {
      alert(first: 1, id: "${alertId}") {
        edges {
          node {
            id
            history (showApprovals: true) {
              edges {
                node {
                  id
                  action # Request Type
                  triggeredBy #from
                  comment
                  completionTimestamp
                  triggeredTimestamp
                  numObjectsPending
                  existingApprovalObjectsCount # Objects
                  approvalDetails{
                    approverGroups  # to
                    additionalApprovers #to
                    approvalStatus
                  }
                  config {
                    ... on ReassignConfig {
                      newAssignee
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

  `
}

interface AlertPendingRequest {
  id: string
  action: string
  triggeredBy: string
  comment: string
  completionTimestamp: string
  triggeredTimestamp: string
  numObjectsPending: number
  numObjectsComplete: number
  approvalDetails: {
    approverGroups: string[]
    additionalApprovers: string[]
    approvalStatus: string
  }
  config: {
    newAssignee: string
  }
}

export const mapQueryAlertPendingRequests = (raw: any): AlertPendingRequest[] => {
  return raw.alert.edges[0].node.history.edges.map(({ node }) => ({
    id: node.id,
    action: node.action,
    triggeredBy: node.triggeredBy,
    comment: node.comment,
    completionTimestamp: node.completionTimestamp,
    triggeredTimestamp: node.triggeredTimestamp,
    numObjectsPending: node.numObjectsPending,
    numObjectsComplete: node.existingApprovalObjectsCount,
    approvalDetails: node.approvalDetails,
    config: node.config
  })) as AlertPendingRequest[]
}

const getPendingRequestLogFilters = (params: {
  id: string
  alertId?: string
  myAlertApprovals?: boolean
}) => {
  const { id, alertId } = params
  const alertIdFilter = alertId
    ? `,
          {
            key: ALERT_IDS
            values: ["${alertId}"]
          }`
    : ''

  return `{
            key: APPROVAL_ALERT_HISTORY_IDS
            values: ["${id}"]
          }
          ${alertIdFilter}`
}

export const queryPendingRequestLog = (params: {
  id: string
  alertId?: string
  page?: number
  first?: number
  myAlertApprovals?: boolean
}) => {
  const { page = 1, first = LIMIT_DEFAULT } = params
  const cursor = getAfterCursor(page, first)
  const filters = getPendingRequestLogFilters(params)
  const myApprovalSubAlerts = params?.myAlertApprovals ? `myApprovalSubAlerts: true` : ''

  return gql`
    {
      subAlert(
        first: ${first}
        after: "${cursor}"
        ${myApprovalSubAlerts}
        filter: [
          ${filters}
        ]
      ) {
        edges {
          node {
            id
            assignee
            generatedAt
            state
            lastAccessTime
            approvalDetails {
              approvalStatus
              approvalRequestAlertHistoryId
              approvalResponseAlertHistory{
                edges {
                  node{
                    triggeredBy
                  }
                }
              }
            }
            objects(first: 1) {
              edges {
                node {
                  id
                  name
                  owner
                  lastModifiedTime
                  riskScore
                  folder {
                    id
                    path
                    name
                    webUrl
                  }
                  template {
                    edges {
                      node {
                        id
                        templateName
                      }
                    }
                  }
                  attribute {
                    count
                    edges {
                      node {
                        name
                        internalName
                      }
                    }
                  }
                  datasource {
                    edges {
                      node {
                        id
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const queryPendingRequestLogCount = (params: {
  id: string
  alertId?: string
  myAlertApprovals?: boolean
}) => {
  const filters = getPendingRequestLogFilters(params)
  const myApprovalSubAlerts = params?.myAlertApprovals ? `myApprovalSubAlerts: true` : ''

  return gql`
    {
      subAlert(
        first: 1
        ${myApprovalSubAlerts}
        filter: [
          ${filters}
        ]
      ) {
        count
      }
    }
  `
}

export const mapQueryPendingRequestLog = (raw: any): PendingRequestLogDetails[] => {
  return (
    raw?.subAlert?.edges?.map(({ node }) => ({
      id: node.id,
      assignee: node.assignee,
      generatedAt: node.generatedAt,
      state: node.state,
      approvalDetails: node.approvalDetails?.map((elm) => {
        return {
          approvalStatus: elm.approvalStatus,
          approvalRequestAlertHistoryId: elm.approvalRequestAlertHistoryId,
          approvalResponseAlertHistory: elm.approvalResponseAlertHistory?.edges?.map(
            (elm) => elm.node.triggeredBy
          )
        }
      }),
      lastAccessTime: node.lastAccessTime,
      fileId: node.objects.edges[0].node.id,
      name: node.objects.edges[0].node.name,
      owner: node.objects.edges[0].node.owner,
      lastModifiedTime: node.objects.edges[0].node.lastModifiedTime,
      riskScore: node.objects.edges[0].node.riskScore,
      folder: node.objects.edges[0].node.folder,
      template: node.objects.edges[0].node.template,
      attribute: node.objects.edges[0].node.attribute,
      datasource: {
        id: node.objects.edges[0].node.datasource?.edges[0]?.node?.id,
        type: node.objects.edges[0].node.datasource?.edges[0]?.node?.type
      }
    })) || []
  )
}

interface RejectAndGrantApprovalRequestParams {
  approvalAlertHistoryId: string
  approvalStatus: 'GRANTED' | 'REJECTED'
  alertId: string
  triggeredBy: string
  subAlertIds: string[]
}

export const queryRejectAndGrantApprovalRequest = (params: RejectAndGrantApprovalRequestParams) => {
  const { approvalAlertHistoryId, approvalStatus, alertId, triggeredBy, subAlertIds } = params
  return gql`
    mutation {
      rejectGrantApprovalForSubAlert(
        actionInput: {
          approvalAlertHistoryId: "${approvalAlertHistoryId}"
          approvalStatus: ${approvalStatus}
          triggeredBy: "${triggeredBy}"
          clientMutationId: "1"
          alertId: "${alertId}"
          subAlertIds: ${JSON.stringify(subAlertIds || [])}
        }
      ) {
        status
      }
    }
  `
}

export const mapQueryRejectAndGrantApprovalRequest = (raw: any): { status: string } => {
  return raw.rejectGrantApprovalForSubAlert.status
}

export const queryAlertDetailPendingRequests = (params: {
  alertId: string
  requestId?: string
}) => {
  const { alertId, requestId } = params
  return gql`
    {
      alert(first: 1, id: "${alertId}") {
        edges {
          node {
            id
            history (showApprovals: true${requestId ? `, id: "${requestId}"` : ''}) {
              edges {
                node {
                  id
                  action # Request Type
                  triggeredBy #from
                  comment
                  completionTimestamp
                  triggeredTimestamp
                  existingApprovalObjectsCount # Objects
                  approvalDetails{
                    approverGroups  # to
                    additionalApprovers #to
                    approvalStatus
                  }
                  config {
                    ... on ReassignConfig {
                      newAssignee
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

export const mapQueryAlertDetailPendingRequests = (raw: any): AlertPendingRequest => {
  try {
    if (!raw?.alert?.edges?.[0]?.node?.history?.edges) {
      return {} as AlertPendingRequest
    }
    const data = raw.alert.edges[0].node.history.edges.map(({ node }) => ({
      id: node.id,
      action: node.action,
      triggeredBy: node.triggeredBy,
      comment: node.comment,
      completionTimestamp: node.completionTimestamp,
      triggeredTimestamp: node.triggeredTimestamp,
      numObjectsComplete: node.existingApprovalObjectsCount,
      approvalDetails: {
        approverGroups: node.approvalDetails?.approverGroups || [],
        additionalApprovers: node.approvalDetails?.additionalApprovers || [],
        approvalStatus: node.approvalDetails?.approvalStatus || ''
      },
      config: {
        newAssignee: node.config?.newAssignee || ''
      }
    }))
    return data?.[0] ?? {}
  } catch (error) {
    console.error('Error mapping alert detail pending requests:', error)
    return {} as AlertPendingRequest
  }
}
